import { ReactComponent as PhotoIcon } from "../../../assets/icons/image_icon.svg";
import { ReactComponent as LayoutIcon } from "../../../assets/icons/grid_icon.svg";
import { ReactComponent as BackgroundIcon } from "../../../assets/icons/background_icon.svg";
import { ReactComponent as StickersIcon } from "../../../assets/icons/favorite_icon.svg";
import { ReactComponent as TextIcon } from "../../../assets/icons/typography_icon.svg";
import { ReactComponent as ThemesIcon } from "../../../assets/icons/paint_icon.svg";
import { ReactComponent as FramesIcon } from "../../../assets/icons/frame_icon.svg";
import { ReactComponent as MasksIcon } from "../../../assets/icons/square_icon.svg";
import { ReactComponent as Device } from "../../../assets/icons/computer_mobile_icon.svg";
import { ReactComponent as Queue } from "../../../assets/icons/upload_que_icon.svg";
import { ReactComponent as NoticeIcon } from "../../../assets/icons/notice_icon.svg";
import { ReactComponent as SettingIcon } from "../../../assets/icons/setting_icon.svg";
import { ReactComponent as ClipArtIcon } from "../../../assets/icons/clipart_icon.svg";
import { ReactComponent as IdeaIcon } from "../../../assets/icons/idea_icon.svg";
import { FaCalendarDays, FaPen } from "react-icons/fa6";
import { FaRegFolderOpen } from "react-icons/fa";
import { PhotoAction } from "../../../tools/photos/PhotosAction";
import { LayoutAction } from "../../../tools/layouts/LayoutsAction";
import { BackgroundAction } from "../../../tools/backgrounds/BackgroundsAction";
import { StickerAction } from "../../../tools/stickers/StickersAction";
import { TextAction } from "../../../tools/text/TextAction";
import { ThemesAction } from "../../../tools/themes/ThemesAction";
import { FramesAction } from "../../../tools/frames/FramesAction";
import { CalendarAction } from "../../../tools/calendar/CalendarAction";
import { MasksAction } from "../../../tools/masks/MasksAction";
import { PhotoFromDevice } from "../../../tools/photos/ImportPhotoFromDevice";
import { AddMyPhoto } from "../../../tools/photos/AddMyPhotos";
import { ImportPhoto } from "../../../tools/photos/ImportPhoto";
import { UploadQueue } from "../../../tools/photos/UploadedQueue";
import NoticeAction from "../../../tools/notice/NoticeAction";
import SettingAction from "../../../tools/setting/SettingAction";
import { ClipArtAction } from "../../../tools/clipart/ClipArtAction";
import { PiPaintBrushFill } from "react-icons/pi";
import { MdDashboard, BsQrCode  } from "react-icons/md";
import { QRCodeAction } from "../../../tools/qrcode/QRCodeAction.jsx";
import ObjectSettingAction from "../../../tools/object-settings/ObjectSettingAction";
import TextSettingPanel from "../../../tools/object-settings/text/TextSettingPanel";
import EditorConfigurationAction from "../../../tools/editor-configuration/EditorConfigurationAction";
import { IdeasAction } from "../../../tools/ideas/IdeasAction";
import { MyProjectsAction } from "../../../tools/projects/MyProjectsAction";
import { AssetsAction } from "../../../tools/assets/AssetsAction";
import { EDITOR_SUB_TYPES, EDITOR_TYPES } from "../constants";
import { BsQrCodeScan } from "react-icons/bs";
export const MenuJSON = [
  {
    icon: PhotoIcon,
    title: "Photos",
    action: <PhotoAction />,
    isActive: true,
  },
  {
    icon: LayoutIcon,
    title: "Layout",
    action: <LayoutAction />,
    isActive: false,
  },
  {
    icon: BackgroundIcon,
    title: "Background",
    action: <BackgroundAction />,
    isActive: false,
  },
  // {
  //   icon: ClipArtIcon,
  //   title: "ClipArt",
  //   action: <ClipArtAction />,
  //   isActive: false,
  // },
  {
    icon: FaCalendarDays,
    title: "Calendar",
    action: <CalendarAction />,
    isActive: false,
    visibilityConfig: {
      allowedEditorTypes: [EDITOR_TYPES.CALENDER],
    },
  },
  {
    icon: StickersIcon,
    title: "Stickers",
    action: <StickerAction />,
    isActive: false,
  },
  {
    icon: TextIcon,
    title: "Text",
    action: <TextAction />,
    isActive: false,
  },
  {
    icon: MasksIcon,
    title: "Masks",
    action: <MasksAction />,
    isActive: false,
  },
  {
    icon: ThemesIcon,
    title: "Themes",
    action: <ThemesAction />,
    isActive: false,
  },
  {
    icon: FaRegFolderOpen,
    title: "My Projects",
    action: <MyProjectsAction />,
    isActive: false,
    // Customer-side only: reuse a design you already saved on another order.
    // Gated by the GLOBAL editor configuration (store-level), like is_downloadable
    // and share_enabled — NOT by settings.selectedMenuItems, which is per-theme and
    // gets serialised into every saved project/theme JSON. `configKey` is the
    // generic hook: Sidebar hides any item whose config flag is off, and
    // SettingAction leaves such items out of the per-theme Menu Visibility grid.
    configKey: "my_projects_enabled",
    // Hides it from admin/superuser/employee sidebars. Does NOT grant visibility.
    customerOnly: true,
  },
  {
    icon: IdeaIcon,
    title: "Ideas",
    action: <IdeasAction />,
    isActive: false,
     visibilityConfig: {
      notAllowedEditorType: [EDITOR_TYPES.CALENDER],
    },
  },
    {
    icon: BsQrCodeScan,
    title: "QR Code",
    action: <QRCodeAction />,
    isActive: false,
  },
  {
    icon: PiPaintBrushFill,
    title: "Edit",
    action: <ObjectSettingAction />,
    isActive: false,
  },
  {
    icon: FaRegFolderOpen,
    title: "Assets",
    action: <AssetsAction />,
    isActive: false,
    adminOnly: true,
  },
  {
    icon: SettingIcon,
    title: "Setting",
    action: <SettingAction />,
    isActive: false,
  },
  {
    icon: NoticeIcon,
    title: "Errors",
    action: <NoticeAction />,
    isActive: false,
  },
  {
    icon: FaPen,
    title: "Editor Configuration",
    action: <EditorConfigurationAction />,
    isActive: false,
  },
];

export const AddPhotoModalJSON = [
  {
    icon: Device,
    title: "Upload Photos",
    action: (openPhotoOption, handleClose) => (
      <PhotoFromDevice
        openPhotoOption={openPhotoOption}
        handleClose={handleClose}
      />
    ),
    isActive: true,
  },
  {
    icon: PhotoIcon,
    title: "My Photos",
    action: (openPhotoOption, handleClose) => (
      <AddMyPhoto openPhotoOption={openPhotoOption} handleClose={handleClose} />
    ),
    isActive: false,
  },
  // {
  //   icon: PhotoIcon,
  //   title: "Import Photos",
  //   action: (openPhotoOption, handleClose) => (
  //     <ImportPhoto
  //       openPhotoOption={openPhotoOption}
  //       handleClose={handleClose}
  //     />
  //   ),
  //   isActive: false,
  // },
  {
    icon: Queue,
    title: "Upload Queue",
    action: (openPhotoOption, handleClose) => (
      <UploadQueue
        openPhotoOption={openPhotoOption}
        handleClose={handleClose}
      />
    ),
    isActive: false,
  },
];

export const FooterJSON = [
  {
    isFront: true,
    front: "../../../assets../../../assets/images/footerImgBlank.webp",
    back: "",
    fronttext: "Front Cover",
    backtext: "",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "Front Inside",
    backtext: "1",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "4",
    backtext: "5",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
  {
    isFront: false,
    front: "../../../assets/images/footerImgBlank.webp",
    back: "/images/footerImg1.webp",
    fronttext: "2",
    backtext: "3",
  },
];

// object wise setting json
export const ObjetctWiseSettingJSON = [
  {
    title: "Lock Object",
    settingProperty: "disabledForClient",
    instruction:
      "Prevent customers from moving or deleting this object in the editor.",
    objectType: ["any"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Exclude from Export",
    settingProperty: "notExportable",
    instruction: "Do not include this object when exporting or downloading.",
    objectType: ["any"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Disable Layer Ordering",
    settingProperty: "disableBackwardForward",
    instruction: "Hide bring-forward/send-backward actions for this object.",
    objectType: ["any"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Auto Background Removal",
    settingProperty: "autoBackgroundRemove",
    instruction: "Automatically remove the image background for customers.",
    objectType: ["img"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Make Object Unselectable",
    settingProperty: "disableObjectEditing",
    instruction: "Prevent customers from selecting or editing this object.",
    objectType: ["any"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Keep Image Fixed",
    settingProperty: "displaySameImage",
    instruction:
      "Always display this exact image for customers (no replacement).",
    objectType: ["img"],
    allowedEditorType: ["any"],
    allowedSubEditorType: ["any"],
  },
  {
    title: "Auto-swap with Kids Content",
    settingProperty: "isTemplateSwapable",
    instruction:
      "Automatically replace with the customer's kids content in AI-generated photobooks.",
    objectType: ["img", "text"],
    allowedEditorType: [EDITOR_TYPES.PHOTOBOOK],
    allowedSubEditorType: [EDITOR_SUB_TYPES.PHOTOBOOK.AI_GENERATED_FOR_KIDS],
  },
];

// global setting json
export const globalSettingJSON = [
  {
    title: "Enable Folding Layout",
    settingProperty: "isFoldable",
    instruction: "Enable folding layout for this editor.",
    notAllowedEditorType: [
      EDITOR_TYPES.PHOTOBOOK,
      EDITOR_TYPES.LAYFLATALBUM,
      EDITOR_TYPES.CALENDER,
      EDITOR_TYPES.ACRYLIC,
      EDITOR_TYPES.CANVAS,
    ],
  },
  {
    title: "Enable Cover Page",
    settingProperty: "coverEnabled",
    instruction: "Allow designing on the cover page.",
    allowedEditorType: [EDITOR_TYPES.LAYFLATALBUM],
  },
  {
    title: "Show Full Cover Spread",
    settingProperty: "showFullCoverSheet",
    instruction: "Display the full cover sheet as a single spread for design.",
    allowedEditorType: [EDITOR_TYPES.LAYFLATALBUM],
    dependentSetting: "coverEnabled",
  },
  {
    title: "Export Spine",
    settingProperty: "exportSpine",
    instruction: "Include the spine area in the exported file.",
    allowedEditorType: [EDITOR_TYPES.LAYFLATALBUM],
    dependentSetting: "showFullCoverSheet",
  },
  {
    title: "Show Full Cover Spread",
    settingProperty: "showFullCoverSheet",
    instruction: "Display the front cover as a full-width spread for design. Automatically hides the back cover.",
    allowedEditorType: [EDITOR_TYPES.PHOTOBOOK],
  },
  {
    title: "Export Spine",
    settingProperty: "exportSpine",
    instruction: "Include the spine area in the exported file.",
    allowedEditorType: [EDITOR_TYPES.PHOTOBOOK],
    dependentSetting: "showFullCoverSheet",
  },
  {
    title: "Hide Back Cover",
    settingProperty: "hideLastCover",
    instruction: "Hide the back cover page in the photobook preview and editor.",
    allowedEditorType: [EDITOR_TYPES.PHOTOBOOK],
    // dependentSetting: "showFullCoverSheet",
  },
  {
    // Layflat duplicate of the same setting — gated on coverEnabled, since
    // there is no back cover to hide when the album has no cover. Shares
    // settingProperty with the photobook entry so they read/write the same
    // state slice.
    title: "Hide Back Cover",
    settingProperty: "hideLastCover",
    instruction: "Hide the back cover page in the album preview and editor.",
    allowedEditorType: [EDITOR_TYPES.LAYFLATALBUM],
    dependentSetting: "coverEnabled",
  },
  {
    title: "Allow Photos",
    settingProperty: "allowImage",
    instruction: "Allow customers to add photos.",
  },
  {
    title: "Allow Text",
    settingProperty: "allowText",
    instruction: "Allow customers to add text.",
  },
  {
    title: "Allow Shapes",
    settingProperty: "allowSticker",
    instruction: "Allow customers to add shapes.",
  },
  {
    title: "Allow Background Remover",
    settingProperty: "allowBackgroundRemover",
    instruction: "Allow customers to remove backgrounds from images.",
  },
  {
    title: "Allow Full Page Export",
    settingProperty: "exportFullPage",
    instruction: "Enable page export",
  },
  {
    title: "Allow Safe Area Export",
    settingProperty: "exportSafeArea",
    instruction:
      "By enabling this option, you can export each safe areas of page as separate files.",
  },
  {
    title: "Apply Maximum Image Upload Limit",
    settingProperty: "applyMaximumImageUploadLimit",
    instruction:
      "By enabling this option, you can set a limit on the number of images a customer can upload.",
    inputType: "checkbox",
  },
  {
    title: "Maximum Image Upload Limit",
    settingProperty: "maxImageUploadLimit",
    instruction:
      "Set the maximum number of images a customer can upload to this theme.",
    inputType: "number",
    dependentSetting: "applyMaximumImageUploadLimit",
    min: 0,
  },
  {
    title: "Allow Image Delete",
    settingProperty: "allowImageDelete",
    instruction:
      "By enabling this option, customers will be able to delete images they have added to their project.",
  },
];
// page wise setting json
export const pageWiseSettingJSON = [
  // {
  //   title: "Half-Size Page",
  //   settingProperty: "isHalfSheet",
  //   instruction:
  //     "By enabling this option, the page will be converted to half its original canvas width.",
  //   notAllowedEditorType: [
  //     EDITOR_TYPES.PHOTOBOOK,
  //     EDITOR_TYPES.LAYFLATALBUM,
  //     EDITOR_TYPES.CALENDER,
  //     EDITOR_TYPES.ACRYLIC,
  //     EDITOR_TYPES.CANVAS,
  //   ],
  //   allowWhenFoldable: true,
  // },
];
export const TempPhotos = [
  {
    src: "/images/photos/A (1).jpg",
    isSelected: false,
    width: 1000,
    height: 1000,
  },
  {
    src: "/images/photos/A (2).jpg",
    isSelected: false,
    width: 1000,
    height: 1000,
  },
  {
    src: "/images/photos/A (3).jpg",
    isSelected: false,
    width: 1000,
    height: 1000,
  },
  {
    src: "/images/photos/A (4).jpg",
    isSelected: false,
    width: 1000,
    height: 1000,
  },
  {
    src: "/images/photos/photo_5.webp",
    isSelected: false,
    width: 1000,
    height: 1000,
  },
  {
    src: "/images/photos/photo_6.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_1.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_2.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_3.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_4.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_5.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_6.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_1.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_2.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_3.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_4.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_5.webp",
    isSelected: false,
  },
  {
    src: "/images/photos/photo_6.webp",
    isSelected: false,
  },
];

export const TempLayoutPages = [
  {
    id: "layout_1",
    name: "Layout_1",
    width: 800,
    height: 800,
    background: {
      color: "#ffffff",
      image: "",
      opacity: 1,
    },
    objects: [
      {
        id: "img_object_1",
        type: "img",
        width: 400,
        height: 400,
        transform: {
          x: 0,
          y: 100,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        image: {
          width: 400,
          height: 400,
          positionX: 0,
          positionY: 0,
        },
        opacity: 1,
        border: {
          radius: 0,
          width: 0,
          color: "#000000",
          style: "solid",
        },
        shadow: {
          color: "#000000",
          offsetX: 0,
          offsetY: 0,
          blurRadius: 0,
          spread: 0,
        },
        effects: {
          brightness: 100,
          contrast: 100,
          saturation: 100,
          grayscale: 0,
          sepia: 0,
          blur: 0,
          sharpness: 0,
          hue: 0,
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        masking: {
          clipPath: "",
          mask: "",
        },
        orientation: 0,
        adjustment: "cover",
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
      {
        id: "text_object_1",
        type: "text",
        text: "Sample Text", // The actual text content
        width: 200,
        height: 70,
        font: {
          family: "Arial",
          size: 1000,
          weight: "normal", // Options: "normal", "bold"
          style: "normal", // Options: "normal", "italic"
          decoration: "none", // Options: "none", "underline", "line-through", "overline"
        },
        color: "#000000", // Text color
        transform: {
          x: 0,
          y: 100,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        editable: false,
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        orientation: 0,
        flip: {
          x: false,
          y: false,
        },
        zIndex: 2,
        draggable: true,
        resizable: true,
      },
    ],
  },
  {
    id: "layout_1",
    name: "Layout_1",
    width: 800,
    height: 800,
    background: {
      color: "#ffffff",
      image: "",
      opacity: 1,
    },
    objects: [
      {
        id: "img_object_1",
        type: "img",
        width: 800,
        height: 800,
        image: {
          width: 400,
          height: 400,
          positionX: 0,
          positionY: 0,
        },
        transform: {
          x: 0,
          y: 0,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        masking: {
          clipPath: "",
          mask: "",
        },
        orientation: 0,
        adjustment: "cover",
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
      {
        id: "text_object_1",
        type: "text",
        text: "Sample Text", // The actual text content
        width: 200,
        height: 70,
        font: {
          family: "Arial",
          size: 1200,
          weight: "normal", // Options: "normal", "bold"
          style: "normal", // Options: "normal", "italic"
          decoration: "none", // Options: "none", "underline", "line-through", "overline"
        },
        color: "#000000", // Text color
        transform: {
          x: 0,
          y: 100,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        editable: false,
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        orientation: 0,
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
    ],
  },
  {
    id: "layout_1",
    name: "Layout_1",
    width: 800,
    height: 800,
    background: {
      color: "#ffffff",
      image: "",
      opacity: 1,
    },
    objects: [
      {
        id: "img_object_1",
        type: "img",
        width: 400,
        height: 400,
        image: {
          width: 400,
          height: 400,
          positionX: 0,
          positionY: 0,
        },
        transform: {
          x: 400,
          y: 0,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        masking: {
          clipPath: "",
          mask: "",
        },
        orientation: 0,
        adjustment: "cover",
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
      {
        id: "text_object_1",
        type: "text",
        text: "Sample Text", // The actual text content
        width: 200,
        height: 70,
        font: {
          family: "Arial",
          size: 24,
          weight: "normal", // Options: "normal", "bold"
          style: "normal", // Options: "normal", "italic"
          decoration: "none", // Options: "none", "underline", "line-through", "overline"
        },
        color: "#000000", // Text color
        transform: {
          x: 0,
          y: 100,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        editable: false,
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        orientation: 0,
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
    ],
  },
  {
    id: "layout_1",
    name: "Layout_1",
    width: 800,
    height: 800,
    background: {
      color: "#ffffff",
      image: "",
      opacity: 1,
    },
    objects: [
      {
        id: "img_object_1",
        type: "img",
        width: 400,
        height: 400,
        transform: {
          x: 200,
          y: 200,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        masking: {
          clipPath: "",
          mask: "",
        },
        orientation: 0,
        adjustment: "cover",
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
      {
        id: "text_object_1",
        type: "text",
        text: "Sample Text", // The actual text content
        width: 200,
        height: 70,
        font: {
          family: "Arial",
          size: 24,
          weight: "normal", // Options: "normal", "bold"
          style: "normal", // Options: "normal", "italic"
          decoration: "none", // Options: "none", "underline", "line-through", "overline"
        },
        color: "#000000", // Text color
        transform: {
          x: 0,
          y: 100,
          scale: {
            x: 1,
            y: 1,
          },
          rotation: 0,
          skew: {
            x: 0,
            y: 0,
          },
        },
        editable: false,
        style: {
          opacity: 1,
          border: {
            radius: 0,
            width: 0,
            color: "#000000",
            style: "solid",
          },
          shadow: {
            color: "rgba(0,0,0,0.5)",
            offset: {
              x: 0,
              y: 0,
            },
            blur: 5,
          },
          effects: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            grayscale: 0,
            sepia: 0,
            blur: 0,
            sharpness: 0,
            hue: 0,
          },
        },
        alignment: {
          horizontal: "left",
          vertical: "top",
        },
        orientation: 0,
        flip: {
          x: false,
          y: false,
        },
        zIndex: 1,
        draggable: true,
        resizable: true,
      },
    ],
  },
];
export const TempLayoutSpreads = [
  {
    src: "/images/layouts/spreads/spread_1.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_2.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_3.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_4.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_5.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_6.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_1.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_2.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_3.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_4.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_5.webp",
    isSelected: false,
  },
  {
    src: "/images/layouts/spreads/spread_6.webp",
    isSelected: false,
  },
];

export const TempBackgroudColors = [
  {
    bgcolor: "#F39F9F",
  },
  {
    bgcolor: "#ADF3C1",
  },
  {
    bgcolor: "#BACCFB",
  },
  {
    bgcolor: "#D6BAFB",
  },
  {
    bgcolor: "#1C1C1C",
  },
];

export const TempBackgroundImgs = [
  {
    src: "/images/background/bg_1.webp",
    isSelected: false,
  },
  {
    src: "/images/background/bg_2.webp",
    isSelected: false,
  },
  {
    src: "/images/background/bg_3.webp",
    isSelected: false,
  },
];

export const TempRecentStickers = [
  {
    src: "/images/stickers/recent_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/recent_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/recent_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/recent_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/recent_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/recent_3.webp",
    isSelected: false,
  },
];
export const TempNatureStickers = [
  {
    src: "/images/stickers/nature_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/nature_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/nature_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/nature_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/nature_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/nature_3.webp",
    isSelected: false,
  },
];
export const TempStickers = [
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/heart_3.webp",
    isSelected: false,
  },
];
export const TempTravelStickers = [
  {
    src: "/images/stickers/travel_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/travel_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/travel_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/travel_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/travel_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/travel_3.webp",
    isSelected: false,
  },
];
export const TempBirthdayStickers = [
  {
    src: "/images/stickers/birthday_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/birthday_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/birthday_3.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/birthday_1.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/birthday_2.webp",
    isSelected: false,
  },
  {
    src: "/images/stickers/birthday_3.webp",
    isSelected: false,
  },
];
export const TempThemes = [
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_1.webp",
    title: "Travel 1",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_2.webp",
    title: "Travel 2",
    isSelected: false,
  },
  {
    src: "/images/themes/travel_3.webp",
    title: "Travel 3",
    isSelected: false,
  },
];
export const TempFramesUsed = [
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
];
export const TempFramesEveryDay = [
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_1.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_2.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_3.webp",
    isSelected: false,
  },
  {
    src: "/images/frames/frame_4.webp",
    isSelected: false,
  },
];

export const TempMasks = [
  {
    src: "path/to/rectangle",
    width: 24,
    height: 24,
    type: "rectangle",
    d: "M0 0 L24 0 L24 24 L0 24 Z",
    isSelected: false,
  },
  {
    src: "path/to/triangle",
    width: 24,
    height: 24,
    d: "M12 0 L24 24 L0 24 Z",
    isSelected: false,
  },
  {
    src: "path/to/circle",
    width: 24,
    height: 24,
    d: "M12 2 A10 10 0 1 1 12 22 A10 10 0 1 1 12 2 Z",
    isSelected: false,
  },
  {
    src: "path/to/heart",
    width: 24,
    height: 24,
    d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z",
    isSelected: false,
  },
  {
    src: "path/to/star",
    width: 24,
    height: 24,
    d: "M12 2 l 2 6 l 6 0 l -5 4 l 2 6 l -6 -4 l -6 4 l 2 -6 l -5 -4 l 6 0 Z",
    isSelected: false,
  },
  {
    src: "custome1",
    width: 200,
    height: 200,
    d: "M191,99.73a1.93,1.93,0,0,1-1.87,1.55l-.56-1.34c-.21,0-.42,0-.62-.06v-.2a88.18,88.18,0,0,0-1.37-15.52l.54,0-.6-.34q-.18-1-.39-2a1.15,1.15,0,0,1,1.07.45c1.15-1.76-1.32-1,0-2.65.22-.2.37-.17.52-.06l-1.2-1.22c.68.13,2-.74,1.78.25a2.71,2.71,0,0,0-1-3.11c-.71-.7-1.29-1.19-.35-2l.24.16c-1-1.63-1.59-1.51-2.27-1.27a4.17,4.17,0,0,1-1.22.31c-.17-.53-.35-1.06-.53-1.59l.83-.63,2.24-1.78-2.17.41c-.06-.38-.18-1.13.69-1.31-1.91-.77-.8.56-2.42.31.6-1.18,0-2.26-.52-3.22s-.71-1.8.79-2.72c-1.78.11-.46,2.1-2.3.84,1.59-1,1.21-1.48.55-1.94s-1.66-.87-1.26-2c1.95-.43,1.76,1.46,2.54-.82-1.69.28-1.9-.51-1.84-1.52s.29-2.21-.33-2.68c-1.15.62-1.76.09-2.33-.79a10.75,10.75,0,0,0-2.18-2.83c.85-.37-1.29-4.49-1.94-6.82l.39-.22a2.44,2.44,0,0,1-2.75-.06c-.72-.48-1.33-1.24-2.09-1.67,1.24-1,1.92-1.15,3-.9,0,0-.25-.3-.52-.6l-.52-.6a2.63,2.63,0,0,1-2.44-.39l1.74-1a5.36,5.36,0,0,0-1.35-1c-.52-.26-1.08-.49-1.62-.76a4.84,4.84,0,0,1-2.56-2.67c-.93.83-1.57,2.85-2.75,3.76l-1-1a1.66,1.66,0,0,1,1.36-.59c-.26-.07-1.18,0-1.23-.62l2-.44c-.37-1.37-1.43.57-2-.2,1-1,.18-1.23,1-2,.27.07.21,1,.86.87a4.71,4.71,0,0,1-.66-3.57c-.46.67-1.27,1.42-2,1-1.64-1.28.58-1.75.11-3.12-1,.4-1.43-1.22-2.79.41-.47-.39.05-1.23.22-1.83-.73,0-1.76-.73-2.7-1.12s-1.73-.46-1.89.81l.14.28c-.07,0-.12,0-.2,0a4.94,4.94,0,0,1-2.57-1,12,12,0,0,1-2-1.81c-1.26-1.38-2.57-2.79-4.3-3.27l.35-.61a28.07,28.07,0,0,1-3.26-.9,4.67,4.67,0,0,0-3.08-.11,1.91,1.91,0,0,1-.18-2.43c-1.7-.16-2.12.45-3.83-1.47,2-.54-.11-1.22,1.89-.22-1.71-1.33-1.79-2.6-4.57-1.58,1.36-1.45-.76-2.67-1.9-2.48l1,1.7a7.86,7.86,0,0,1-2.93-1l1.23-2.1a3.66,3.66,0,0,0-2.9-1.4,10.62,10.62,0,0,0-3.14.5c-2.05.56-3.79.86-5-1.79-1.44,1.44,2.12,1.58.71,3.3-1.84-.65-3.35-4.4-4-4.51-1.3-.84-2.08-.06-2.85.78s-1.53,1.67-2.9,1.13c.29.87.37,3.15-1.73,3.8-1.86-.46-2.17-3.74-.86-4.33.48,0,.69.25.65.54.66-.26,1.55-.56.82-1.54l-.32.83a7.24,7.24,0,0,0-2.12-1c-.72-.3-1.25-.63-.89-1.32-1.35.66-.9,1.2,0,1.64a6.44,6.44,0,0,0-2.86-.46,11.25,11.25,0,0,1-3.4-.26c.44.46.84,1.44.42,1.45-2-.48-2.37-.07-2.61.52s-.32,1.34-1.59,1.63c-1.55-1.18.32-3.13-2.23-1.84-1.69-.75-.56-2.22.05-3a2.87,2.87,0,0,1-1.73.66A4.16,4.16,0,0,1,89,4.29a16,16,0,0,0-2.82-1.07l1.23-.85a4.3,4.3,0,0,1-2,.67l1,1.57c-.8-.21-1.44-.06-1.54-.78-.6,1.24,1,2.69-.23,4.46-1.13-.66-2.78,1.42-3.57-.68,3,.13-.12-1.78,1.27-2.76a2.88,2.88,0,0,1-1.39.05c-.17-.22,0-.49.2-.65C77.59,3,80.19,7.06,77.12,7.71,77.21,6.38,75.8,5.54,75.36,6c1.27-.33,1.12,1.88.27,3.14-2.2-.41-1.89,1.3-2.92,1.47L74,10.7C74,12,73,12.13,71.82,13a.6.6,0,0,1,0-.64c-.48.51-1.26.29-2.12,0-1.11-.35-2.34-.68-3.07.42-1.25-.43-1-2.19-2-2.4a2,2,0,0,1-2.44.92,2.2,2.2,0,0,0-2.58.84c1.41,1.23,1.32.81.4,3.06l3.34-2.83-.74,1.7-.7,1.68c1.14-.48,2-2.09,2.78-2.09-.64,1.76-.65,1.34.43,2.4-1.27-.84-1.9-.14-2.48.65S61.48,18.36,60.25,18l-1.82-3.82c-1.77-.14-2.77.94-3.73,2.22a7.49,7.49,0,0,1-3.87,3.27l.73,0h.72c.42,1.69-1.89,1.48-2.58,2.72-.68-1.24-1.62-1.25-2.57-1.68.64.83-2.43,1.61-1.05,4.1l-1.26-.26-1.25-.22c-3,1.38-.34,5.34-2.82,6.88-.33-1.74-2-1.6-1.2-3.77-.78.65-1.64,1.06-1,1.81-.51-.14-.74.67-1,1.48s-.56,1.61-1.36,1.44c.12.74,1,1.9.18,2.58a1,1,0,0,1-.41-.38c.25.57-.49,1.8,1.15,2.19a4.14,4.14,0,0,0-3.15.59,6.7,6.7,0,0,0-1.16,1c-.34.38-.65.8-1,1.21a12.85,12.85,0,0,1-1.94,2.27,3.53,3.53,0,0,1-2.69,1l-.78,1.55-.78,1.61c-.52,1.06-1.09,2.06-1.58,2.9-.28-.34-.58-.39-.26-.62-2.57,1.58,2.49,3.6-.34,5.35-1.36.08-1.43-.42-1.3-.91s.48-.91-.16-.73c-2.11-1-2.44-.12-2.68,1.08s-.35,2.66-2,3V55.2c-1.07.35-1.14,1.45-1.11,2.71s.21,2.7-.49,3.82a1.21,1.21,0,0,0-.63-.3A9.52,9.52,0,0,1,16,65.69c.05,1.48-.18,2.92-.23,4.19-1.47-1.33-.55-1.39-2.44-1.56-.11,1.14,2.9.71,2.69,2.92-1.16.35-2.52,1.57-4.44,1.22,0,0,.11-.52.27-1l.29-1c-1.39.11-1.61.78-1.54,1.54s.42,1.58.05,2.06l-1-.45c-.58,3.29,2.22,4,1.23,7.31l.91-.17c1.14,1.19.72,1.49.17,1.78s-1.17.58-.31,1.67l-2.89.08c.12.34.29.81.5,1.35s.47,1.16.74,1.81a19.6,19.6,0,0,1,1.14,3.77c-2-1.42-2.69-4.17-3.71-6-.2,1.24-.34,4.3,1,5.08-.21-.53-.81-1.24-.32-1.68a7.16,7.16,0,0,1,2.72,6.2C8,94.38,7.65,96,7.41,97.89S7.21,102,5.09,103a8.7,8.7,0,0,1,.59,1.66,8.88,8.88,0,0,1,.3,1.67,19.05,19.05,0,0,1-.07,3.45c-.07,1.18-.19,2.39-.22,3.64a13.92,13.92,0,0,0,.4,3.82c3.87-2.59.39,1.49,4.63.33.48,1.09.55,1.53.29,1.7l.13-.28c-.06.13-.1.19-.15.3h0l-.86,2c-.22.52-.43,1-.6,1.43s-.25.66-.25.66c-.5.58-.82.37-1.11,0s-.56-.76-1-.58c.33,2.71-1.51,1.56-2.15,3.64,1.41-.78,2.42.31,2.28,2l.66-1.34.67-1.33c1.63,1.48,1,2.5.37,3.57s-1.21,2.17.5,3.6l-1.7-.69c1.37,1.61,2.66,7,6.69,7.18-.32.52-1.21,1.45-1.86.8a9.14,9.14,0,0,0,1.91,3.16,29.82,29.82,0,0,0,2.71,2.8,18.39,18.39,0,0,1,2.42,2.66,4.92,4.92,0,0,1,1.13,2.87l-1.09.28c.75.57,2.47.17,2.22,1.65-.4.21-1.08.32-.9.69.58.17,2.87.79,3,2.09l-1.54-.09a5.19,5.19,0,0,0,1.76,2.54,8.79,8.79,0,0,0,2.52,1.32c1.84.62,3.78.94,5.28,2.07A3.69,3.69,0,0,0,31,166a10.27,10.27,0,0,0,1.41,3.36l-.36.28A12.82,12.82,0,0,0,35,172a21,21,0,0,0,3.27,1.45c1.1.41,2.28.69,3.43,1s2.28.72,3.46,1.15a5.7,5.7,0,0,0,1.41,3.09,17.3,17.3,0,0,0,3,2.6c1.13.86,2.41,1.58,3.58,2.42a20.33,20.33,0,0,1,3.17,2.67c-.41-.86,1.23-2.13,2.13-2,.73,1.13,3.75-.65,2.38,1.91l-.35-.22c-.4,2.92,2.1,3.29,3.82,4L66,186.7a5.45,5.45,0,0,0,3,3.35,12.62,12.62,0,0,0,4.31.95,18.49,18.49,0,0,1,4,.56,3.15,3.15,0,0,1,2.33,2.34c1.34-.64,2.75-.38,4-1.11l-.42,2a23.6,23.6,0,0,0,4,1.16,20,20,0,0,0,2.1.27l1.23.07,1.42,0-1,1.38c2.32.3,3.32-5.58,5.29-5.61l.49,3c1.94,0,3.9.75,5.88,1a9.19,9.19,0,0,0,3,0,6.4,6.4,0,0,0,2.83-1.39c0,.45-.06,1.33-.7,1.5,1.84,0,7.46,1.24,6.2-2.78.43,2.73,4.05-.38,5.8-2l.09,2c1.2-2.89,1.08-3.58,3.25-4.8.54.1.81,1.12.29,1.16,1.74.23.79-2.25,3.16-1.86l-.48,1.46c1.94-.4,1.62-1,2.17-2.75.9-1.15,3.63-.68,4.54.9-.12-1.14.34-2.9,1.58-2.83a1.33,1.33,0,0,1,0,1.39,3.69,3.69,0,0,0,2.12-.58,6.79,6.79,0,0,0,1.36-1.31c.79-.92,1.47-1.68,2.91-1.28.33.57.6.8.86.89a22.65,22.65,0,0,1-4.24,1.66c.72,1.66,2.83,1.08,2.26,4.1.54-1,1.18-2.49,1.94-3.74s1.61-2.34,2.74-2.43a3.17,3.17,0,0,1,.54.44l-.09.28a1.32,1.32,0,0,0,1-.87,4.32,4.32,0,0,0,1.78-.39c1,1.19,2.61-.51,3.55-1.05-1.13-1.67.21-2.14-1.76-2.85.21,0,0,.32-.6.76-.1.13-.25.25-.28.4l0-.19c-.57.4-1.33.89-2.21,1.43.22-1.31.52-2.47,2.1-2.09-.2-1.38-.42-2.84-.48-3.54A12.93,12.93,0,0,0,152,177.2a6.92,6.92,0,0,1,3.08,1.07c1-1.42,2.49-2.68,3.55-4.21a8.18,8.18,0,0,0,1.24-2.4,5.66,5.66,0,0,0,0-2.87c.36-.95,1.49.14,2.15.36-.15.63-.66,1-.52,1.6a23.62,23.62,0,0,1,2-3c.65-1,1-2.09.24-3.18,2.47-.73.8,2.65,2.73.12l.28.88a5.06,5.06,0,0,0,3.59-2.6,15.47,15.47,0,0,0,1.13-4.25,12.6,12.6,0,0,1,1.16-4.2,6,6,0,0,1,3.48-2.72,1.11,1.11,0,0,1-.8,0,12.11,12.11,0,0,0,1.15-1c.34-.36.67-.73,1-1.11a21.7,21.7,0,0,0,1.7-2.44,44.74,44.74,0,0,0,2.5-5.45c.37-.93.75-1.85,1.14-2.75a28.51,28.51,0,0,1,1.24-2.69,27.66,27.66,0,0,1,1.55-2.53,15.78,15.78,0,0,1,2-2.33c1.43-1.84-.08-2.63-.89-4.26l2.22.2-.27-.45c-.16-.28-.38-.64-.6-1-.45-.71-.89-1.43-.89-1.43a2.21,2.21,0,0,1,.62-2.17,17.68,17.68,0,0,1,2-1.77,5.94,5.94,0,0,0,1.73-2.07,3.25,3.25,0,0,0-.39-2.93l-1.53.26a13.13,13.13,0,0,0,.36-2.78c.08-.93.31-1.63,1.12-1.4-.24-.19-1.44-.67-.61-1.13l1.13.09s-.36-1-.75-1.89l-.83-1.85c.51-1.33,1.62-1.16,2.67-1.14s2.08-.13,2.26-2.22C194.61,102,191.81,99.15,191,99.73Zm-42.19,82.15c0-.08,0-.17,0-.26a3.73,3.73,0,0,1,.26,1c-.48.6-.89.38-1.18.07A7.49,7.49,0,0,0,148.85,181.88Zm37.07-102.5a1.09,1.09,0,0,1-.24.24c-.07-.26-.13-.52-.2-.79A6.23,6.23,0,0,1,185.92,79.38Z",
    isSelected: false,
  },
  {
    src: "path/to/crescent-moon",
    width: 24,
    height: 24,
    d: "M16 12 A8 8 0 1 1 10 2 A6 6 0 1 0 16 12 Z",
    isSelected: false,
  },
  {
    src: "path/to/octagon",
    width: 24,
    height: 24,
    d: "M8 2 H16 L22 8 V16 L16 22 H8 L2 16 V8 Z",
    isSelected: false,
  },
  {
    src: "path/to/cross",
    width: 24,
    height: 24,
    d: "M9 2 H15 V9 H22 V15 H15 V22 H9 V15 H2 V9 H9 Z",
    isSelected: false,
  },
  {
    src: "path/to/parallelogram",
    width: 24,
    height: 24,
    d: "M4 4 L20 4 L16 20 L0 20 Z",
    isSelected: false,
  },
  {
    src: "path/to/right-triangle",
    width: 24,
    height: 24,
    d: "M2 2 L22 2 L2 22 Z",
    isSelected: false,
  },
  {
    src: "path/to/ellipse",
    width: 24,
    height: 24,
    d: "M12 2 A10 8 0 1 1 12 22 A10 8 0 1 1 12 2 Z",
    isSelected: false,
  },
  {
    src: "path/to/diamond",
    width: 24,
    height: 24,
    d: "M12 2 L22 12 L12 22 L2 12 Z",
    isSelected: false,
  },
  {
    src: "path/to/pentagram",
    width: 24,
    height: 24,
    d: "M12 2 L20 9 L16 20 H8 L4 9 Z M12 6 L14.5 14 H9.5 Z",
    isSelected: false,
  },
  {
    src: "path/to/cloud",
    width: 24,
    height: 24,
    d: "M16,10a4,4,0,0,0-7.9-1.33A4.5,4.5,0,0,0,2,13.5A4.5,4.5,0,0,0,6.5,18H18a4,4,0,0,0-2-7.5Z",
    isSelected: false,
  },

  {
    src: "custome3",
    width: 24,
    height: 24,
    d: "M23.7,12c0,1.47-1.96,2.54-2.48,3.81-0.55,1.32,0.06,3.46-0.94,4.46s-3.26,0.39-4.46,0.94c-1.28,0.53-2.36,2.54-3.81,2.54s-2.54-1.96-3.81-2.54c-1.32-0.55-3.46,0.06-4.46-0.94S2.69,17.1,2.14,15.89C1.57,14.46,0.5,13.47,0.5,12s1.07-2.54,1.63-3.81c0.55-1.32-0.06-3.46,0.94-4.46s3.26-0.39,4.46-0.94C9.53,2.69,10.5,0.5,12,0.5s2.54,1.96,3.81,2.54c1.32,0.55,3.46-0.06,4.46,0.94s0.39,3.26,0.94,4.46C21.74,9.53,23.7,10.5,23.7,12Z",
    isSelected: false,
  },
  {
    src: "custome4",
    width: 200,
    height: 200,
    d: "M194.68,136.3c-.58-.08-1.19.14-1.67-.7-.13-.24-.35-.33-.53-.49l.58-.48c.22-.17.23-.42,0-.49-.55-.17-.64-.75-.68-1.61-.07-1.9-.54-2.66-1.75-3.14a1.13,1.13,0,0,0-.39-.75,5.55,5.55,0,0,1-.72-.79.44.44,0,0,1,0-.56.57.57,0,0,1,.18-.17l.83-.3c-.17-.8-.58-.35-.87-.48a4.6,4.6,0,0,1-.61-.25c-.15-.07-.19-.86-.06-1a1.1,1.1,0,0,1,.6-.3c.47,0,.64-.39.62-1.15a1.46,1.46,0,0,1,.41-1.16,2.11,2.11,0,0,1,1.82-.78,1,1,0,0,1,.39-.72c.41-.33.43-.51.23-.86s-.6-.73-1-.68-.51-.3-.47-.57a1.87,1.87,0,0,0-.93-2.12c-.49-.34-.31-1.64-.87-1.9,0-.22.08-.55.15-.57a5.15,5.15,0,0,1,1.08-.21c.36,0,.51-.38.52-1a4.63,4.63,0,0,0-.23-2.16c-.22-.48-.33-1.1-.53-1.61a1.66,1.66,0,0,1,.08-1.35,1.25,1.25,0,0,0,.06-.59c0-.23-.55-.19-.57.08-.08,1.08-.66,1.14-1,1.65-.23.33-.38.12-.53-.13a1.58,1.58,0,0,1-.19-1.63,5.22,5.22,0,0,0,.23-2.52c0-.38-.17-.67-.43-.69l-.85,0,0-1.47a7.64,7.64,0,0,1-1.06-.12c-.21,0-.21-.26-.09-.54s.32-.76,0-.83c-.62-.14-.62-.82-.64-1.55a1.84,1.84,0,0,1-.62,0,2.61,2.61,0,0,1-.59-.35c.17-.16.35-.31.51-.48a.57.57,0,0,0,.16-.26.32.32,0,0,0-.08-.22,1,1,0,0,0-.41-.17,8.26,8.26,0,0,0-1.11-.06c-.26,0-.4-.25-.49-.6s0-1.46.3-1.61c.42-.23.7-.53.45-1.29a5.73,5.73,0,0,1-.35-1.75,2.62,2.62,0,0,0-.16-.67c-.17.22-.42.38-.49.68a16.35,16.35,0,0,0-.28,1.77.45.45,0,0,1-.15.27s-.13-.12-.13-.2c-.09-1-.66-1.62-.58-2.74,0-.52-.2-.67-.38-.33-.44.8-1.1,1.36-.95,2.8,0,.25-.22.61-.36.89-.29.56-.73.54-.91,0,0-.11,0-.26-.06-.37a4,4,0,0,1-.17-3.11c.25-.58-.15-.45-.29-.58-.62-.57-.61-.59-.43-2.17a3.77,3.77,0,0,0,0-1c3.27-.42,6.55-.87,9.82-1.35l-10.37.08,0,0v0h-.79a4.41,4.41,0,0,1-.25-.39c-.13-.24-.3-.61-.53-.19s-.38.08-.56-.1-.37.21-.55.32-.42.21-.61-.11-.34-.41-.54,0c-.11.2-.23.37-.34.55h-1.28c.18-.12.35-.28.52-.38s.1-.17.14-.26-.1-.21-.17-.24c-1.33-.52-2.76.47-4.06-.67-.5.94-.9.33-1.34-.19-.1-.11-.29,0-.44,0-1,0-1.92-.05-2.88,0-.4,0-.69-.27-1-.6s-.58-.17-.67.45a2.48,2.48,0,0,1-.65,1.46.4.4,0,0,1-.42.1c-.34-.19-.1-.51,0-.8.23-1,.15-1.31-.29-1.34s-1-.06-1.55-.08-1.09.22-1.55-.07c-1.22-.79-2.43-1.59-3.77-1.52-.61-1-1.39-.6-2.11-.68a13.38,13.38,0,0,1-1.55-.05c-.34-.08-.65-.52-1-.62s-.72.76-1.22.67a13.22,13.22,0,0,0-2,0,.9.9,0,0,0-.82.37,3,3,0,0,1-3.11,1.13v-.72c.35,0,.72,0,1-.59.34-.76.79-1.06,1.35-1,.06,0,.14-.29.18-.46s-.12-.24-.16-.22c-.9.45-1.74-1.32-2.65-.23-.45-.91-.9-.29-1.36,0-.57-.86-1.27-.39-1.92-.55-.49-.12-.83.19-1.15.81a1.7,1.7,0,0,1-.48.6l0,0s0,.05,0,.08a.56.56,0,0,1-.2.11,3.5,3.5,0,0,0-.54-.48c.17,0,.37,0,.37-.23a4,4,0,0,0-.76.15.66.66,0,0,0-.64-.24.23.23,0,0,1-.06-.13c-.22.07-.29.33-.48.44-.25-.43-.88-.06-1.28-.53-.25.17-.56.63-.69.08-.2,0-.15.28-.3.32s0-.53-.15-.56c0,.27-.18.14-.3.42-.1-.28-.35-.32-.47-.57a2.2,2.2,0,0,1,.67-.42.11.11,0,0,0-.11.12c.28,0,.43.19.64.31a.5.5,0,0,0-.08-.47c0,.11,0,.27-.05.29s-.13-.21-.19-.31c.24,0,.49,0,.73,0h0c.49,0,1,0,1.46-.07.09,0,.19-.36.23-.58s-.09-.27-.15-.39a4,4,0,0,0-.38-.67c-.81.88-1.38-.26-1.89-.82a3.57,3.57,0,0,0-.46-.43,9.92,9.92,0,0,0,2.24,0c0,.14-.09.17-.11.3.27-.07.33-.41.61-.45,0,.11,0,.27.08.27s.13-.08.18,0c0-.31-.21-.1-.2-.35.37-.45.86,0,1.36-.45.12.27.42.23.59.41.06-.42-.1-.59.15-.78.14.42.44.81.05,1.14.11,0,.05.26.14.28,0-.5.36-.43.67-.46-.07-.42.39-.49.43-.24,0-.21.14-.36.36-.33.26.47-.15.51-.16.69.17-.08.51.06.56-.16-.38-.08.3-.19,0-.58-.13,0,0,.23-.24.32-.05-.36.06-.51.22-.6.23.09.25.71.29.83.15-.16.44.18.62-.26-.29.28-.75-.07-.59-.51.26-.06.1.36.2.36s.57-.37.46.23c.26-.16.21-.38.09-.68.29-.07.27.3.15.47.16-.09.13.17.26.16.12-.29-.13-.52,0-.76.13,0,.14.24.21.35.22-.09.29-.38.61-.35.15.63.39,0,.65.5,0-.24-.13-.29,0-.39s.08.35.21.36c0-.24,0-.46.1-.49s0,.11.07.09c0,.15-.16.09-.11.3.77-.37.93-.43,1.45.21.08-.41.45-.3.63-.16-.07-.3.08-.31.1-.49-.3.12-.16-.26-.15-.46-.23-.12-.32,0-.57-.13,0,.3-.21.26-.3.42a1.1,1.1,0,0,0-.27-.45c0,.23-.44.36-.49.25s.46,0,.35-.43c-.27.22-.27-.1-.07-.28a3.49,3.49,0,0,0-1.44.17c0-.23.14-.42,0-.58-.09.53-.53-.08-.83-.1.1,0,.24,0,.25-.12-.1-.28-.18,0-.27-.26.1,0,0-.16-.07-.18-.08.3,0,.37-.09.58a1.58,1.58,0,0,1-1.63-1.06c.27.26.5-.27.82.1,0-.23.11-.22,0-.48a8.4,8.4,0,0,1-1.08-.26c.07-.15.06-.24-.07-.28,0,.11,0,.22-.12.2.06-.14.06-.24-.08-.28,0,.19-.27.34-.3.13.34-.09.07-.53.24-.75l.18,0c.1.13.07.43.18.28-.06,0,0-.17,0-.27l.3,0a.38.38,0,0,0,.19.29.8.8,0,0,1-.08-.28l.36,0a.35.35,0,0,1,0,.11.2.2,0,0,0,.21-.09h.11s0,0,0,.05.1,0,.11,0l.48,0a1.34,1.34,0,0,0,.05.2c0-.1.18-.12.24-.17h.09s0,0,0,0,.13.06.2,0l.43,0h0c-.09.06-.33-.08-.31.13.22.28.44,0,.7.2a.61.61,0,0,1,0-.29h.11c.07.18.26.21.35,0,.15.18,0,.31.09.47,0-.26.36-.25.36-.33s-.1,0-.12-.11l.5.05a.08.08,0,0,0,.06.1.3.3,0,0,0,0-.1l1,.1s0,.08,0,.17h.12c0-.06,0-.11.06-.1s0,0,0,0a.81.81,0,0,0,.36-.05c0,.06,0,.1,0,.16s.17-.13.2-.26a.83.83,0,0,0,.21-.17.29.29,0,0,0,0,.19,2.54,2.54,0,0,1,1-.22c0,.06,0,.11,0,.2s.18.1.19.06a5.61,5.61,0,0,0,.19-.62l-.17,0,.06-.25c-.34,0-.48-.42-.7,0,0-.15-.07-.29-.1-.42v0a.72.72,0,0,1,.14-.28s0,.05.05.05a.31.31,0,0,1,0-.1c.19-.14.44.17.76.94.2.05.34-.07.48-.23.06,0,.12,0,.17-.1s-.06,0-.08,0a4.34,4.34,0,0,1,.35-.49c.25-.29.52-.55.79-.83l.08,0h0l.15,0c.06-.5.24-.31.46-.82a.64.64,0,0,1-.75.11.23.23,0,0,1,0,.1.29.29,0,0,0,0-.08.05.05,0,0,1,.06,0l-.16-.07v.05a5.74,5.74,0,0,0-1.32-.31l-3-.34a.53.53,0,0,1,.17-.27c0-.14-.33-.37-.21-.46s.2.16.31,0c0,.13,0,.26,0,.39.47-.57.8-.25,1.31-.15.05-.35.24,0,.31-.23-.06,0-.29-.23-.14-.27s.36.44.57.13c0,.21,0,.35.14.36,0-.36.28-.1.1-.49.14.19.25,0,.37-.13-.92-.32-1.85.2-2.84-.26,0,.17.11.24,0,.29-.28.06-.44-.29-.7-.11,0,.45.2-.09.2.17-.2.34-.45.15-.75.18a.45.45,0,0,0-.14-.37c.23.05.31.42.5,0-.16,0-.43-.26-.5,0-.09-.08-.2-.09-.25,0,.15,0,0,.31,0,.29-.19-.18-.35.21-.45-.14.2,0,.49,0,.43-.34-.4,0-.57.1-.76-.1,0,.21,0,.31-.18.31-.23-.51-.69.13-.86.29a1.25,1.25,0,0,0-.32-.44l.54,0c.07,0,.16-.17.22-.3a.84.84,0,0,0,0-.3s0,0-.06,0,0-.09,0-.14c0,.16-.24,0-.26-.07.14.1.29-.18.12-.2a.41.41,0,0,0-.13.24c-.3-.27-.57-.75-.88-1a1.19,1.19,0,0,1,.16.08c.2,0-.17-.26.05-.29s.58.24.76.1c0,.11,0,.27.07.28.16-.72,1.1.09,1.31-.24-.07,0-.16,0-.07-.09s.13.47.34.44c0-.23-.24-.39-.09-.47.16.32.08,0,.25-.12.12.2.35.14.33.34.43-.7,1,.08,1.38-.06,0,.35.28.34.46.43,0-.36-.31-.15-.33-.44a3.5,3.5,0,0,0,1.91-.7c.06.25-.11.2-.11.39.24.05.12-.38.3-.41.32.38.72.91,1,.26-.1,0-.23.06-.26-.06.17,0,.63-.54.88-.1-.06.13,0,.36-.17.4a.25.25,0,0,0-.26-.16c0,.29-.16.27-.16.5.24.11.1-.28.3-.23,0,.26-.1.2,0,.38.07-.22.48-.3.35-.52.18.4.64-.24.89.19-.05.24-.34-.22-.3.22a.69.69,0,0,0,.5,0c0-.43-.12.09-.14-.18-.07-.42.58-.37.41-.62-.34.41-.88,0-.92.39-.16-.25-.43-.27-.54-.61.23,0,.18-.05.56-.16.06.29.55.91.51.14-.21.1-.28-.06-.32-.25.22.2.26-.33.5-.06-.06-.42-.55-.05-.63.07,0-.12.07-.14,0-.29a2.45,2.45,0,0,1-2-.35c0,.49.44.26.48.71-.06,0-.07.08-.12.11,0-.3-.22-.3-.45-.24a.83.83,0,0,0-.22-.55c-.25.66-.82.3-1.19.14,0-.13.11-.1.12-.21-.4-.09-.63,0-.68.27,0-.2-.38.26-.44,0,0-.07.24-.32,0-.39-.09.29-.39.32-.67.36,0-.22-.09-.4-.21-.45-.17.17.15.43,0,.58-.17-.37-.55,0-.78-.49.05.24,0,.35-.17.31,0-.11.09-.65,0-.38.07.33-.46.28-.44,0,.51,0,.19-.58.6-.74,0,.09.05.11.07.18s-.17.14-.11.4c.3,0,.29.25.5-.06.12.19.23.14.15.46.23,0,.09-.47.29-.51s.19.14.38,0c0,.1,0,.19,0,.29.32-.22.15,0,.43-.34a.67.67,0,0,1,.34.63c.12-.08,0-.53.1-.58.35,0,.5-.22.75,0,0,.15-.17.07-.17.21l.25,0c0-.31-.14-.28,0-.48-.66.34-1.23-.22-1.81.21a.81.81,0,0,1-.09-.47c-.29.1-.56.19-.17.31-.09.06-.15.16-.24.22,0-.42-.37-.44-.32-.16,0-.33-.2.23-.19-.07s.3-.26.48-.44c-.23-.26-.65.11-.94.2.22-.43-.45,0-.51-.23s.4-.23.17-.4c-.23.32-.53.18-.72.66-.4-.62-1.06.69-1.58-.11-.08.3-.4.18-.56.06,0-.21.37,0,.23-.4a.59.59,0,0,0-.42.43c-.13,0-.14-.25-.26-.26,0,.17-.3.37-.31.23s.1-.12.18-.12a.37.37,0,0,0-.2-.36c0,.14,0,.35-.05.39-.11-.43-.49-.62-.85-.86,0,.48-.38-.14-.3.41.22,0,.56-.3.32.06.18.22.37-.17.5,0a1.28,1.28,0,0,1,0,.19c-.32.09-.59-.45-.88-.09.07,0,.17,0,.19.08s-.07.08-.12.11-.07-.37-.26-.26c.21.5-.65,0-.6.73-.14-.34-.11.08-.37,0,0-.1-.06-.11-.07-.18s.3-.36.1-.5c0,.24-.41,0-.36.33.1-.08.28.16.13.18s-.31-.55-.51-.13c.07,0,.16.14.07.18-.32-.28-.5,0-.82-.1.16-.14.43-.15.48-.44a.35.35,0,0,1-.51-.22c0,.34.18.47,0,.57,0-.28-.35-.07-.39-.34.13.33-.19.52,0,.58.16-.35.05.24.13.18s.33-.19.31,0c-.16,0-.44.24-.3.32,0-.23.21,0,.2.08s-.19,0-.38,0,.2.3,0,.38c-.37,0-.66-.3-1.14-.06.21-.26-.34-.34-.15-.56.17.14.53.23.62-.16-.3.13-.84.22-1.07-.07a.64.64,0,0,1,.76.1,4.69,4.69,0,0,1,.13-1.16c-.2-.05-.44.31-.36.33s.18-.4.25-.13-.11.45-.29.51c-.16-.3-.27,0-.51-.13.08-.38-.18-.18-.21-.36s.16,0,.31,0c-.08-.6-.25,0-.43.05a.66.66,0,0,1,0-.39.26.26,0,0,0-.24.22c.28.09,0,.84-.34.71-.11-.22-.14-.16-.09-.47-.12,0-.13.12-.24.12,0-.34-.26-.23-.28-.54-.24.14-.3,0-.36.33s.23,0,.25.16-.29.37-.37.14.14-.52-.15-.56c.17.49-.09.07-.17.31a.83.83,0,0,1,.22.64h-.1l-.35-.24a.35.35,0,0,0,.24-.22c-.17-.18-.37-.09-.56-.05l-.17-.16c.07-.11.1-.3.19-.4-.16-.11.1-.3-.08-.38a.42.42,0,0,1-.17.41c0-.3-.39-.4-.28-.64-.1,0-.22.15-.34.21a.39.39,0,0,1-.08-.1.31.31,0,0,0-.09-.07c.13-.33.52-.33.74-.55,0,.26.14.17.2.27-.09-.23.28-.27,0-.39-.09.36-.18-.15-.31-.06,0,.45-.43-.1-.68.27,0-.15,0-.35,0-.39s.25.21.25,0c-.15,0-.24-.12-.44,0,0,.17-.05.22-.18.21.09.27.06.35-.1.49,0-.3.13-.41-.09-.47a2.29,2.29,0,0,1-.17.56h0l-.31-.06c0-.1.12-.32,0-.34a.88.88,0,0,1-.07.32L126,60h0c.33-.05,0,0,0-.3.07,0,.07-.08.12-.11-.08.28.29.24.26.07s-.07-.5,0-.57c-.27.2-.44.21-.54.54-.28,0-.55-.1-.46-.52.15,0,.16.19.26.26.25-.27.52-.37.66-.56-.16.17-.19-.39-.08-.37s.48.38.45,0c.13.53.53.26.6.7.22,0,.2-.26.29-.42,0,.25.24.13.33.25-.12.19.07.32.14.46,0-.29.45.13.25-.12a.41.41,0,0,1-.2-.17c.2,0,.24-.16.37-.23,0-.33-.28-.12-.22-.55.12,0,.27,0,.33.15-.15.08.17.17.14.37.26-.15.31,0,.62-.07,0-.51-.28,0-.57-.13,0-.73-.55-.6-.68-1.16-.21.11-.16.45-.37.13,0,.16,0,.32,0,.48.2,0,.13-.31.37-.23.08.08.23.06.26.25-.17.05-.22.17-.49.25,0-.33-.31-.07-.33-.34.11.68.55.31.79.86a1.5,1.5,0,0,1-1.11-.83c-.11,0,0,.15-.05.2s-.11-.11-.12,0c.12-.06.33.22.2.27-.17-.12-.41-.12-.52-.33s.12-.14.19-.2h.22c.18,0,.36-.33.54-.62a1.12,1.12,0,0,0,.39-.1.6.6,0,0,1,.05-.29c-.09,0-.13-.05-.16-.13a.24.24,0,0,0,0-.08.36.36,0,0,0,0-.1c.33.26.34.58.51,1.13.21-.22-.05-.35,0-.48.11.25.26-.18.37-.23l.47.1a1.14,1.14,0,0,0,0,.36c0,.43.16.87.5.77.16,0,.43-.11.46-.27a1.2,1.2,0,0,0-.18-.68c0-.23.27-.08.23-.35-.31.15-.07.06-.08-.28-.15.06-.28.15-.43.22l-.13-.12a1,1,0,0,0-.14-.31c0,.29-.1-.21-.25-.07s.1.24.08.47c-.06,0-.07.09-.12.11-.05-.22-.1-.43-.27-.44,0,.16.1.23,0,.28,0-.17-.54.26-.32-.25-.12,0-.31.13-.26-.16-.17.25-.37-.28-.48.11a.27.27,0,0,0-.08-.11c-.5-.13-1-.11-1.54-.26a.81.81,0,0,0,0-.27c-.1,0-.14.12-.16.23a1.65,1.65,0,0,1-.46-.3l0-.05c-.16,0-.33-.24-.47-.3a2.92,2.92,0,0,0-.34-.23c.43-.19.72.2,1.23,0,.06-.44.34-.25.28-.7.08.36.3.57,0,.76.21.07.43-.31.29-.42-.09.08.13-.25-.2-.26a.65.65,0,0,1,.36-.33c.13.17,0,.18,0,.48a.68.68,0,0,0,.44,0c.15-.13-.15-.35,0-.49a1.25,1.25,0,0,0,.46.43c.28-.62.82-.28,1.24-.33,0,.22.13.64.21.36a1.12,1.12,0,0,1-.22-.55c.24.14.28.29.51,0,0,.51.31,0,.45.34,0-.15-.09-.49,0-.49h.13c0,.34-.1.47-.09.77.24.12,0-.42.24-.31,0-.28-.1-.24-.09-.47.28.06.58-.31.88.09.05-.37.25-.2.37-.33.1.06,0,.47.2.36,0-.18.06-.22,0-.38-.08,0-.15,0-.14-.18.17-.69.79-.26,1.12-.23.09,0,.59-.5.39.15.16-.11.4-.2.39.25-.14,0-.19-.22-.39-.15,0,.28-.14.34-.16.59.28-.1-.08.27.2.17s-.19-.47,0-.58c.09.09.24.06.27.26-.09,0-.06.22-.11.3.12,0,.46.21.5,0s-.29,0-.32-.16.1-.79.05-.2c.23,0,0-.55.36-.42,0,.16-.08.26,0,.29s0-.25.17-.41c.16.12.16.26.21.36.21-.29.76.14.42-.43.11,0,.26,0,.32.16-.18.1-.06.15,0,.39a1.47,1.47,0,0,1,.82.09c.07-.22-.18-.34,0-.38,0,.25.1-.14.25,0s0,.36.08.38c.26,0,.56-.23.63.12-.08.06-.32-.08-.3.13.26.26.41-.29.62-.07,0-.13,0-.26,0-.38.26,0,.47-.39.52.22-.27-.18-.49.36-.35.71.19,0,.41-.09.51,0,.15-.14-.13-.27,0-.38.23.13.77-.43,1.06-.22-.07-.19-.32-.05-.33-.35.42-.35,1,.22,1.26,0-.1-.1-.26-.09-.33-.25.29-.16.58.13,1,.08.09,0,0-.18.12-.21.27,0,.63.47.73.78,0-.63-.31-.56-.48-.81.31-.25.42.25.69-.07-.06-.15-.31,0-.27-.26-.51.2-1.06.49-1.44,0,.42.15.15-.08.36-.33.19,0,.5.35.57.23s-.07-.08-.07-.19c.19-.23.55.19.5-.06-.1,0-.16-.05-.19-.16.54-.27.86.14,1.17-.33.08.63,1-.17,1,.46a5.71,5.71,0,0,0-1.37.15c.11.23-.2.2-.3.32.34.44.81-.14,1.11-.31,0,.12.09.12.08.27-.23,0-.26.2-.49.16.06.16,0,.51.21.45,0-.18-.08-.2-.08-.37l.5-.06c.15.64,0,.61,0,1.25-.08,0-.09-.12-.19-.08.06.68-.3.8-.51,1.12.23.25.21-.39.55-.26,0,.11-.1.23,0,.29,0-.3.31-.07.23-.41a.25.25,0,0,1-.32-.16c.08,0,.05-.17.11-.2s.2.12.32.15,0-.19.06-.2c0-.38-.22.13-.21-.36.25-.61,0-1.32.58-1.11.17.48.42.22.75.1a.62.62,0,0,1,0,.29c.13,0,.68.23.68-.17,0-.21-.15.14-.31,0,0-.31-.22-.1-.21-.35.54-.16.62,0,.72.49.58-.06.89.18,1.7.19.08-.23-.18-.34,0-.38.22.14.28-.08.57-.07-.07.15-.06.24.07.28.2-.34.32.3.37-.23.16,0,.19.28.27.45.06-.14,0-.36.11-.49-.26-.07-.56-.25-.53-.52-.13.11-.53.31-.62.17.08-.27.52-.38.86-.31,0-.12,0-.24,0-.36.2-.08.27.19.31-.14-.26-.34-.41.69-.86.29.33,0,0-.25.16-.4-.37.1-1.25-.85-.48-.9,0-.32-.12-.34-.27-.35,0,.24,0,.34-.17.3,0,.18.1.56,0,.58s-.38-.14-.49.15c-1-.39-2.28,0-3.4-.09a.67.67,0,0,1,.5-.05c0-.56.31-.26.36-.33-.18-.08.19-.12,0-.29.48-.11.88,0,1.17-.42-.49,0,.17-.61-.15-.56-.21.6-.65.51-1,.21,0,.12,0,.27,0,.3-.21-.33.23-.36.36-.52a4.93,4.93,0,0,0-.71-.31c0-.14.08-.31.23-.31s.18.18.45,0a.6.6,0,0,1,0,.29c.18,0,.18-.24.36-.24l0,.48a1.33,1.33,0,0,1,.72-.75c-.41-.13-.9-.9-1.23-.53,0-.16-.21-.57-.09-.66.27.2.27.29.57,0,0,.12-.08.14,0,.29.5-.05.24.65.78.58.1-.16.14-.41.29-.51-.15,0,0-.44,0-.48.13.18.24.23.12-.11.26.2.74,0,.9.38,0,.22-.09.29,0,.57-.31.3-.89.17-1.3.25,0,.18.05.31.14.36,0-.2,0-.3.17-.3a.71.71,0,0,1,0,.48c.15,0,.3-.06.32.15l-.25,0c0,.47.5.63.65.5a.42.42,0,0,1-.2-.27c.09,0,.1-.17.18-.21.24.05.09.33.21.46.12-.28.06.21.13.17s.08-.31.24-.31,0,.35.08.37c.56-.8,1,.44,1.68-.28,0,.24.21.25.34.34,0-.35-.18-.51-.23-.84-.27,0-.85.16-1-.26.13,0,.37-.25.5,0,0-.15,0-.35.05-.39.69.14,1.61-.36,2.19-.06-.13,0,0-.42-.14-.46-.22.4-.53.31-.76,0-.39.35-1.09.24-1.49.36,0-.53-.62-.59-.55-1-.17,0-.49.18-.57,0,.17,0,.16-.33.29-.42-.15-.07-.28-.19-.5-.13,0-.24.1-.32-.09-.38-.51.08-1.11.27-1.64-.29.05-.55.52-.27.73-.47-.25-.16.3,0,.24-.21-.17,0-.18-.58,0-.67.13.07.23.21.21.55.16,0,.32-.06.3-.32-.35.21-.09-.5-.21-.46a.52.52,0,0,1-.17.31c0-.56-.34,0-.44.15-.21-.27-.87.42-1.2-.16.17-.13.32-.23.5-.15a.81.81,0,0,1,.46-.72c.14.18,0,.19,0,.39.18-.06.39-.63.56-.16-.11,0-.36.29-.24.31.33-.31.64-.92,1-1a.7.7,0,0,0-.08-.37c.56-.21,1.15-.79,1.43-.26.21-.09.59.05.69-.18-.23-.06-.25-.52-.4-.43a1.61,1.61,0,0,0,.47-.63c.08.28.45,0,.58.22s-.3,0-.24.22c.68.58,1.8,0,2.47.49-.13.29-.56-.22-.61.26.24.2.56,0,.89.28.06.35-.08.43-.29.42,0-.57-.86-.19-.61-.89-.29.25-.65.33-.88,0-.12,0,0,.38-.24.32,0-.19.08-.2.11-.3-.32.45-1.49.2-1.91.69,0-.17-.06-.31-.15-.36,0,.22-.19.28-.22.5.22-.13.21.18.32.25,0-.14.3-.36.37-.14s-.17.13-.17.31c.05,0,.12,0,.13.08s-.12,0-.12.11c.28,0,.61-.64.81-.19-.24-.07-.11.34-.24.41-.29-.19-.74.19-.86.29.39-.14.34.5.59.61-.23.16-.13-.25-.32-.16a1,1,0,0,0,.36.92c-.17,0-.11.21-.17.31.17.13.51-.05.33.44.19,0,.48-.17.51.13s-.52,0-.48.44c1-1.24,1.58,1.28,2.6.37-.06.46.16.41.27.55a3.7,3.7,0,0,1-.39.9c-.13-.16-.16,0-.31,0-.19-.15,0-.38-.21-.36a.7.7,0,0,0,.08.37c-.28.09-.38,0-.82-.1-.09.34-.26.35-.16.69.43-.17.61.18,1-.3-.14.21.24,1,.34.44-.09,0-.23.06-.25-.07s0-.35,0-.39c.26.07.42-.33.45.14-.09-.11-.24-.09-.25.13.22,0,0,.17.2.26a.53.53,0,0,1,.82-.09c0,.1,0,.19,0,.29-.29-.17-.42.67-.3.22.47.21.64-.64.71-.94.17-.06.07.35.2.36,0-.44.32-.48.47-.72-.1.05-.23-.34-.08-.38.39.15,1.14-.13,1.45.22,0,.17-.19.32,0,.38,0-.66.54.12.69-.17s-.26-.1-.21-.46c.31.06.19-.45.41-.52.27.31,1.07.15,1.32-.06-.12-.32-.34.14-.45-.24.09-.19,0-.59.15-.78.11.11.43-.09.55-.25-.24-.06-.33-.21-.08-.38-.53-.13-.81.25-1.38.16a.57.57,0,0,1-.1.4c-.05-.17-.3,0-.32-.16s.37-.16.35-.52c-.19,0-.74.39-.7-.11l-.31,0c.06.67-.78.4-.57-.12-.3-.06-.76.15-.78-.39a.82.82,0,0,0,1-.21c-.12,0-.13-.26-.32-.16,0,.25-.12.2-.18.31,0-.22-.28-.06-.32-.25s-.12-.28-.15-.46c.28-.31.62,0,.88.09,0-.37-.36,0-.39-.34s.17-.07.18-.21-.45.1-.51-.13c.14-.14.41-.11.42-.44a2.15,2.15,0,0,1,.58.42c-.14-.34.29-.43.33-1-.29.39-.7.88-1,.21-.31.15-.81.23-1-.08a1,1,0,0,0,.35-.52c-.15-.39-.48.33-.69.08.08,0,.15,0,.11-.2s-.2.2-.29.32c-.12,0-.34-.43-.16-.65.79.29,1.47-.1,2.28.41-.48.22-1-.46-1.24.24.28-.29.41.24.55-.16.28.13.34.55.59.31-.22.11-.08-.24,0-.28a1.26,1.26,0,0,0,.45.14c0-.51.59-.3.59-.84-.59.61-1.26,0-1.78-.37-.17.16.13.38,0,.49a.44.44,0,0,1-.2-.27c.16-.49-.05-.35-.23-.83.34-.2.23.42.46.42s.38-.5.49-.34-.11.1-.12.2.16.13.26.17c0-.22,0-.36.11-.4.06.47.21.79.54.8,0-.17-.11-.23,0-.29.23.2.58.15.78.4.1-.33.28,0,.49-.25,0,.43.56-.09.58.31,0-.07,0-.11.12-.1,0-.94-.85-.23-1-.75.35,0,.22-.22.05-.29.47-.53,1,.66,1.07.07.16,0,.58.48.51.23-.29-.13-.06-.07-.08-.47-.07-.2-.39.25-.51,0,0-.13.45-.11.24-.22-.27.1-.25,0-.42.24-.1-.1-.12-.35-.22-.45-.09.08,0,.46-.17.4-.13-1-.92-.36-1.29-.81a7.48,7.48,0,0,1,2.31-.26c-.06,0-.08-.16,0-.2l.19,0a.81.81,0,0,0,.09.47c.23-.24.27.2.51.23a3.09,3.09,0,0,1,2.08.05c.31,0,1.38-.24,1.71.38,0-.14,0-.35.05-.39a13,13,0,0,0,1.27.34c0-.13-.06-.37.05-.39s.16.34.27.45c.29-.63.73.31,1.12-.13-.09-.47-.28-.12-.25,0-.11,0-.26,0-.32-.16.27,0,0-.14,0-.28s.15-.13.25,0c0-.75-.67,0-.94,0s-.19-.7-.54-.61c0,.19.1.18.14.27-.27.15-.62.38-.82,0,.22-.09,0-.41-.14-.37-.11.24-.22.12-.42.34.15-.47-.38,0-.16-.56-.32,0-.1.28-.29.42-.18-.38,0,.07-.25.12,0-.19-.19-.16-.08-.37-.35,0-.54.27-.81.09a2.09,2.09,0,0,1-.17.4,1.27,1.27,0,0,0-.88-.09c0-.73-.94-.59-1.25-1.1,0,.11,0,.27,0,.29s-.16-.55-.33-.25.26.09.21.45c-.33.14-.88.44-1.24.24.21.1.34-.37.23-.41-.15.17-.24.41-.48.44.06-.13,0-.36.1-.49-.34-.09-.69.19-.94.11a.28.28,0,0,1,.12-.21c.44-.13,1.15.26,1.37-.25-.44.19-1-.25-1.57.08,0-.53-.83.26-1-.36a2.17,2.17,0,0,1-2.27-.12c.05,0,.07-.09.05-.2a.49.49,0,0,0-.37.23c.08,0,.15,0,.14.18-.44,0-.56-.08-.82,0,0-.15.08-.25.11-.4-.37.17-.39-.28-.76-.1,0,.26.21.24,0,.47,0-.27-.19-.22-.27-.35-.11.16.13.39-.1.49-.4,0-.4.08-.81.19,0-.38-.39-.32-.22-.65-.38,0-.49-.23-.68.18.08-.3-.15-.37,0-.68-.12,0-.13.12-.25.12,0,.21.17.51,0,.58-.69-.12-1.55-.41-2,.14a.74.74,0,0,1,.05-.39l-.31,0c.05.25,0,.35-.18.31.14-.41-.14-.16-.15-.56.27-.27.53.1.89.19.12-.57.95-.41,1.06-.12-.28-.59-1.2-.51-1.46-.31a3.06,3.06,0,0,0-1.22-.54c.05.26-.12.2-.17.31,0,.3.12.27.09.57.24.11.1-.28.3-.23-.07.47.27.21.22.65-.3-.05-.73-.43-.81.09l-.32,0c.06-.13.05-.35.11-.49-.36,0,.08.5-.29.52-.13-.16-.16-.39-.26-.07-.2-.3.11-.53,0-.67,0,.16-.42.21-.44,0s0-.36.11-.39c-.08.49.37-.09.56-.07s.1.38.21.46c0-.47.35-.08.44,0-.08-.61-.44-.45-.59-.51,0-.3.21-.09.29-.42-.25.11-.51.4-.63,0,0,.24-.44,0-.29.42.19.11.3-.3.37,0-.22.45-.4,0-.63-.12-.06.32.21.05.14.37-.06,0-.07.09-.12.11-.34.06-.39-.14-.65-.41-.17.08.11.14.08.28s-.13.07-.18.12a.36.36,0,0,1-.21-.36c0-.25.24-.1.17-.4-.24.1-.32.13-.5,0-.13.1-.09.42-.3.42s-.13-.25-.26-.26a.55.55,0,0,1-.75.08c-.06.2-.2.28-.3.42.31.06.44-.17.58.13a.46.46,0,0,0-.18.21c.15,0,.18-.17.3-.23,0,.6.39,0,.45.24s-.08.19,0,.39c.35-.29.89-.46,1.13.06-.09-.56.66-.19.39.24.33,0,.1-.28.3-.41,0,.17.14.22.14.46-.55.55-.92.19-1.45-.22-.39.31-.56.12-.81.28,0-.09,0-.19,0-.28,0,.26-.69.16-.48.44.12-.25.53-.12.57.12-.39.11-.61-.09-1,0,.07-.32,0-.27-.15-.46,0,.56-.39.42-.31.13-.55.13-1.18-.24-1.82.11a.39.39,0,0,0-.7-.11.6.6,0,0,1,0-.29c-.25.13-.31-.07-.39-.25-.23.29.27.32.09.47-.17-.08-.39-.07-.46-.33-.44,0-1.38.36-1.76,0-.37.34-2.48.53-1.7-.09a7.76,7.76,0,0,0-1.25.14c.31-.07-.12-.05,0-.38-.18.1-.21.14-.32-.06,0,.45-.43-.11-.55.25a.05.05,0,0,1,0,.1,5.82,5.82,0,0,0-.16-.56c.15-.26.21-.08.43-.24-.13-.32,0-.32.1-.58-.81.23-.69.09-1.39,0,0,.35.31.08.33.35l-.31,0c0,.18.06.32.15.37,0-.35.19,0,.23-.31.1.07.25,0,.21.36-.11,0-.32-.06-.24.21.15-.09.28-.17.38.06-.33.36-1.16,0-1.62.37-.2-.31-1.37-.36-1.31.15a1.26,1.26,0,0,1-.21-.45c.2-.12.69.13.67-.27-.28.1-.7.25-.45-.24-.17,0-.13.3-.3.32,0-.12,0-.25,0-.38s.61,0,.36-.23c-.1.28-.4,0-.5,0-.1.2-.79.34-.89-.19a.3.3,0,0,1,.11-.2c.21,0,.52.25.57-.06a.52.52,0,0,1,0,.47c.31,0,0-.29.17-.4.1.18.21.38.32.06a1.47,1.47,0,0,0-1.64-.1c-.27-.37-1,.36-1.17-.64a.37.37,0,0,1-.57-.22c-.2,0-.11.28-.31.23-.37-.17-.3-.55-.49-1.09,0,.52-.48.48-.68.26,0-.12.11-.1.12-.2-.23-.3-.31.53-.5.06-.15-.3.35-.18.11-.3-.21.24-.31-.28-.43.14-.11-.05-.12-.27-.21-.36-.13.4-1.29.44-1.14-.25-1.17.45-2.84-.39-3.92-.32,0-.19,0-.41.17-.4s.11.42.26.06c-.12,0-.16-.08-.14-.27.19-.13.39.25.5-.05-.19,0-.62-.11-.76-.11s0,.44-.16.59c.07-.7-.26,0-.4-.34.19-.15,0-.57-.08-.37.16,0,0,.31,0,.29-.25-.08-.34-1-.53-.61,0,.23.28-.08.2.27s-.38,0-.56,0c-.08.57-.37.77-.73.65.27,0,.11-.18.1-.49-.38,0-.66.15-1-.17.12,0,.62,0,.43-.14-.33.14-.37-.24-.21-.46-.29.22-.3-.17-.56.16,0-.12-.08-.12-.07-.28s.09-.23.24-.22a2.93,2.93,0,0,0-.54-.7c-.07.24.26.27.08.37-.19-.06-.23.09-.31.18,0-.12-.11-.27-.18-.29s0,0-.07.06-.25,0-.33-.13c.26-.44.56.32.69-.18-.17,0-.4-.1-.34-.44.15-.07.46.07.5-.15-.32-.15-.57.05-.66-.6-.09.43-.51,0-.74.37-.12-.18,0-.19-.08-.37-.19.18-.27-.32-.32-.06.16,0,0,.31,0,.29,0-.24-.22-.16-.39-.14,0-.3-.12-.27-.09-.57-.55.3-1-.2-1.44-.22a1.41,1.41,0,0,0-.21-.23c0-.12,0-.23-.08-.21l-.06.11,0,0-.28,0h0c-.27-.19-1.2.1-.9-.57-.22.31-.77.55-.76,0-.15.07-.08.29-.08.42l-.13,0a1.13,1.13,0,0,0-.88-.3,2.67,2.67,0,0,1-.75-.55c-.29.37-.57.64-.68,0a4.47,4.47,0,0,1,1.49-.1c0-.52-.33-.38-.35-.82,1.39-.76,2.6-1.16,3.87-.54,1.42-.33,2.93.21,4.23-.86a11.39,11.39,0,0,1,3-.15c-.42-.71-1.42.19-1.91-.45a4.66,4.66,0,0,1,.09-.68,1.66,1.66,0,0,1-.92-1,2.1,2.1,0,0,1-1.93-.83c-.2-.05-.11.27-.3.22,0-.23-.13-.19-.09-.47a.29.29,0,0,1-.51-.13c-.37.38-.37-.19-.74.18,0-.1,0-.19,0-.29a2,2,0,0,1-1-.26c.17-.46.38-.83.8-.71,0,0,.11-.19.16-.29s-.14-.3-.21-.31q-1.27-.21-2.55-.36A2.21,2.21,0,0,1,104,19.48a2,2,0,0,0-2.2-1.67c-.34,0-.53-.36-.56-.87,0-1-.26-1-.68-.48-.28.36-.49,1.11-.9.84s-1-.66-1.14-1.22c-.21-1.11-.5-1.63-1.17-1.56s-1.27-.17-2,.32c-.5.36-1.09-1-1.77-.58a.72.72,0,0,0-.23.28.51.51,0,0,0,.1.31,4.2,4.2,0,0,1,.71.69,1.55,1.55,0,0,1,.07.87.88.88,0,0,1-.4.52.55.55,0,0,1-.57,0,5.88,5.88,0,0,0-2.65-1.26c-.08,0-.14-.21-.21-.33.13-.16.25-.43.4-.48.36-.11,1,.18,1-.31,0-1-.69-.65-1.09-.7-2.28-.23-4.57-.4-6.85-.64-.52,0-.9.39-1.33.67-.62.4-.93-1-1.53-1a9.47,9.47,0,0,0-1.39.19c-.24.05-.4.63-.73.14-.57-.85-1.21-.8-1.83-.1-.34.39-.5-.18-.7-.41-.89-1-1.61.68-2.43.39s-1.64-1.78-2.65-.55c-.2.25-.54.11-.81.23-.54.24-.86-1.3-1.52-.44-.48.63-1.11.15-1.67.11-2.09-.13-4.19-.28-6.28-.45-.66,0-1.3-.21-1.93.48-.35.39-.72,0-1-.58-.38-.85-.78-1.37-1.36-.44-1.12-.07-2.14.95-3.29.8-3.14-.39-6.28-.77-9.43-.91-.82,0-1.39-1.51-2.09-1a2.76,2.76,0,0,1-2.21.53c-.86-.15-1.53,1.1-2.46.75a1.91,1.91,0,0,0-2.63,1.11c-.2.37-.7.38-1.06.39A7,7,0,0,1,31.4,13c-.73-.23-1.23.53-1.84.82-.07.35-.12.81-.43.62C29,14.37,29,14,29,13.78c-1.3.64-2.56,1.64-4,1.58a.55.55,0,0,0-.49.29,1.85,1.85,0,0,0-.16.85c0,.42.17.57.34.39.34-.37.66-.71.73.39a1.56,1.56,0,0,0,.06.46A6.55,6.55,0,0,0,27.63,19c.33-.27.5-.2.5.4,0,.27-.12.76-.21.79-.72.19-1,.56-.44,1.71a1.6,1.6,0,0,1,0,.89c-.28.76-.46,0-.62-.24s-.55-.39-.77-.13a3.07,3.07,0,0,0-.91,1.75c-.18,1.12-.74.7-1.17.81-.62,1.13-.82,1.13-1.12.1-.08-.27-.07-.62-.15-.88s-.65-.46-.74-.15a1.53,1.53,0,0,0,.07.73c.15.36.18.73,0,.74-.92.09-1.36,1.68-2.21,2-.69.23-.06,1-.14,1.25a3.8,3.8,0,0,0,0,2.47c.12.49-.15,1-.42,1-1.5-.14-2,1.15-2,3.52,0,1.17-.62,1.6-1.5.72-.53-.53-.79-.2-1.17.07-.42-.92-.77-.45-1.11.17-.42.78-.74.42-1.16-.1s-.72,0-.81.73a4.63,4.63,0,0,1-.28,1.8,8.26,8.26,0,0,0-1.5,2.78c-.25,1.53.91,2.25,1.28,3.52a1.62,1.62,0,0,1,.13.41A3.64,3.64,0,0,1,10.8,48c-.28.41-.51,1-1,.78a.9.9,0,0,1-.38-.58c-.07-.61-.15-1.17-.53-1.38a9,9,0,0,0,.52-1.54,2.64,2.64,0,0,0-.27-1.22c-.06-.15-.38-.15-.51,0a8,8,0,0,0-1.56,4.31c-.08.51,0,1,.31,1.18.56.27.85.52.29,1.43A11.41,11.41,0,0,0,7,52.45a.89.89,0,0,0,0,.46,1.66,1.66,0,0,0,.15.39c.76-1.17,1.83-.14,2.62-1.07a1.05,1.05,0,0,0,.09-.37.53.53,0,0,1,.25,0c.81.26.75.22.6.91a11.75,11.75,0,0,1-2.18,4.3,2.45,2.45,0,0,0-.63,1.49A3.85,3.85,0,0,1,6,62.18a2.21,2.21,0,0,0-.71.69c-.18.26-.52.57-.19,1.1.19.31.42.77.63.78s.7-.41,1.06-.47c.69-.13,1,.55.86,1.75-.09.58-.54,1.16-.48,1.61a10.28,10.28,0,0,1,.37,2.24c-.06.94-.34,2.08.07,2.79.51.9-.34,1.64.08,2.49a7,7,0,0,1,.15,2.69c.15-.08.35-.12.42-.3.29-.8.53-1.66.81-2.48a4.72,4.72,0,0,1,.32-.68c.08.43.18.86.22,1.3s0,.65,0,1c0,1.22.12,1.4.8,1.45s1.11.24,1.61-.53c.3-.46.59-1.24,1.17-.5.35.45.89.46,1.27.87a2.51,2.51,0,0,1,.21,1.27A41,41,0,0,0,14.59,84a27.21,27.21,0,0,0,.82,5,8.84,8.84,0,0,1,0,2.31H14.9c-1,0-1,0-1.21,1.64-.14,1-.23,1.06-.65.45a6.54,6.54,0,0,0-.85-1.24c-.17-.14-.63.12-.71.4a3.77,3.77,0,0,0,.5,3c.62.61,1.3.45,2,.46a.44.44,0,0,0-.07.19c0,.11,0,.22,0,.33,0,.42.11.66.32.75s.49-.16.51-.69a3,3,0,0,1-.48-.47l-.1-.11h.1c.48,0,.45-.87.68-1.27a.69.69,0,0,1,.24-.24,4.05,4.05,0,0,0-.4,2.05c.76-.05,1.47,0,1.38,1.87,0,.13.36.32.54.49a1,1,0,0,1,.25.92c-.06.42-.29.66-.48.5-.4-.35-.69-.51-1.14,0s-.82.95-1.31.29c-.72,1-1.56.45-2.35.55s-.73,0-.62,1.67c0,.22.08.39-.07.62a7,7,0,0,0-.46.82,1.09,1.09,0,0,0,.16,1.45c.62.69.64,1.06.11,1.88-.1.16-.23.34-.36.37s-.27-.1-.41-.16a5.77,5.77,0,0,1,.1-.6,1.41,1.41,0,0,1,.13-.29c-.2-.36-.41-.7-.62-1a9,9,0,0,1-.25,1c-.23.59-.57.5-.83-.16-.12-.3-.2-.71-.36-.84a.59.59,0,0,0-.65,0,2.15,2.15,0,0,0-.79,2c0,.83.34.9.74,1.06.88.37,1.73,1.36,2.63.09.45.83.9.54,1.35,0a.58.58,0,0,1,.14.28c.13,1.44.52,1.09,1.07.62.21-.18.63.36.94.59.07,0,.11.17.16.26s-.09.21-.15.24c-.46.24-.93.47-1.4.7-.48-.9-1.13-.61-1.67-.48s-1.09-.6-1.64-.77c-.08,0-.19.23-.29.36a1.51,1.51,0,0,1,0,1.56,1,1,0,0,0,.18,1,.42.42,0,0,0,.21.08,1.64,1.64,0,0,1,.44,0,1.66,1.66,0,0,1,.37.34c-.1.14-.2.37-.31.4-.36.09-.52.45-.45,1,.05.38.28.51.51.5s.44,0,.67,0,.42,0,.4.49c0,.1-.23.2-.36.29s-.4.28-.16.71c.31.59.64,1.12,1.11.42.14-.22.25-.32.35-.12.35.68.81.47,1.24.51s.59.14.63.78.09,1.19-.21,1.35c-.74.39-.81,1.54-1.09,2.46a4.74,4.74,0,0,1,.52.49c.15.16.28.13.3-.22.07-.83.22-1.15.65-.47l.83-1.06c.05-.06.12-.08.18-.13a2.26,2.26,0,0,1,.12.67,19.45,19.45,0,0,1-.54,2c-.24.72-.52,1-1,.36-.24-.33-.78-.38-1,.26s.24.85.49,1.26a20,20,0,0,1,1.2,2.91l.86.06a6.78,6.78,0,0,0-.25.91c-.15.89.34.49.52.7s.65.56.94.9a1.14,1.14,0,0,1,.11.65,1.57,1.57,0,0,1-.23.58c0,.07-.14,0-.21,0-.29,0-.66,0-.78.46a1.78,1.78,0,0,0,.45,1.55c.27.4.48.89.87,1.09.58.29.89,1.23,1.26,2a3.84,3.84,0,0,0,.88,2.84,3.54,3.54,0,0,1,.47,2.35c-.16,1.46.49,2.52.58,3.89.06.86.64,1.26,1.21,1.09.25-1.05.71-2,1.28-2.18,1.1-.32,2-1.51,3.16-1.56a4,4,0,0,0,.1,1,.76.76,0,0,0,.56.4,11.73,11.73,0,0,0,1.33.08,2.1,2.1,0,0,1,.43.05c.06,0,.11.15.17.23s-.17.45-.23.44c-.91-.23-1.67.73-2.53.9-.33.07-.26,1.82-1,.81a5,5,0,0,1-2.19,1.53,1.64,1.64,0,0,0-.66,1.38,6.34,6.34,0,0,1,0,.76c-.2,1.17-.68,1.71-1.27,1.13s-1.52.11-2.08-1a3.14,3.14,0,0,0-.21.61c-.05.43-.18.69-.42.72a2.89,2.89,0,0,1-.88,0c-.8-.11-1.49,0-1.43,1.86,0,.15-.34.34-.53.51s-.22.34-.1.5.12.19.18.18c.28,0,.58.17.84-.22s.56-.83.85-1.21c.17-.22.54.23.59.74,0,.23,0,.48,0,.72l-.92.8c-.45.41-.47.44-.18,1.45.14.46.35,1.13.06,1.28-.58.29-.6,1.46-1,1.72a4.34,4.34,0,0,0-1.61,2.82c-.07.28-.18.2-.31-.09-.34-.78-.46-.8-.74-.18s-.2,1.19.06,1.26c.8.19.68,1.09.6,2,0,.41-.44.63-.17,1.25.37.81.22,1.34-.38,1.56a.29.29,0,0,0-.09.48,1.35,1.35,0,0,1,.69,1.57c-.24,1.45.43,1.6.9,2.13.28.32.38-.07.55-.19s.35-.25.4-.16c.46.73,1.14.46,1.58,1.06a5.07,5.07,0,0,1,.17,1.4c0,.11.09.19.13.29a1.2,1.2,0,0,0,.26-.4c0-.23,0-.5,0-.75.06-.65.33-1.06.55-.82.74.77,1.66.74,2.37,1.6a1.69,1.69,0,0,1,.15.59c-.12.07-.26.12-.33.27-.45.93-1,1.46-1.71,1.31-.33-.06-.56.24-.76.62a2.54,2.54,0,0,0-.16.59s.11.19.18.19c.36,0,.73,0,1.09.05.74,0,1.48,0,2.21.07a.51.51,0,0,1,.34.36,2.44,2.44,0,0,1-.15,1,2.1,2.1,0,0,1-.68.86,2.69,2.69,0,0,0-.83,1.17,1.4,1.4,0,0,0,.14,1c.14.07.28.1.41.16s.48,0,.61.27c.73,1.23,1.15-.53,1.75-.47a3.19,3.19,0,0,0-.09-.59,6.41,6.41,0,0,0-.45-.82c-.16-.26-.16-.46,0-.55s.31-.12.41,0c.36.42.66,1.15,1,1.29.57.22.78-1,1.23-1.35.05,0,.12,0,.18,0,.11,1.17-.21,2-.84,2.26-.46.22-.32.42-.19,1,.21.9.48,1.4,1.1,1.37.35,0,.4.6.41,1.13a2.24,2.24,0,0,0,.08.71.49.49,0,0,0,.36.32.42.42,0,0,0,.36-.26c.4-.87.43-.94.76-.35.49.89,1,1,1.56.27.36-.48.66-.29,1,.15s.7.36,1,.07.41-.39.74-.09c.77.68,1.72,0,2.52.95.31.36.63-.49.89-.91s.61-.65.94-.12c.14.23.23.2.38.1.83-.59,1.66-.89,2.47.15.18.22.44.21.6-.12.32-.62,1.07-.42,1.06-1.65a.91.91,0,0,1,1.46-.23,4.41,4.41,0,0,1,1.66,1.77c.22.54.67.41,1,.24.13-.06.24-.29.37-.4,1.07-.91,2.1-1.61,3.29-.36a.91.91,0,0,0,1.47-.25c.47-.71.81-.24,1.12.34s.47.74.89.26c.26-.31.7-.16,1.06-.25A.79.79,0,0,0,52,188c.22-.23,0-1.13.41-1s.44.66.67,1c.11.14.31.3.39.22a.9.9,0,0,1,1.33,0c.08.06.3-.12.36-.29.16-.44.1-1.53.64-.55.38.69.79,1,1.36,1,1.55-.08,3.11-.11,4.67-.07.56,0,1-.23,1.35-1s.83-.75,1.2-.33a1.49,1.49,0,0,0,1.24.57c1.63,0,3.26,0,4.89-.05a.75.75,0,0,0,.63-.22c.41-.58.75-.49,1.18,0a.68.68,0,0,0,.84.16c.47-.37.88-1,1.37-.14,1.57-1,3.18-.39,4.78-.5.59,0,1.26.28,1.76-.1.86-.65,1.62-1.13,2.46-.07,0,0,.12-.11.17-.19.33-.48.66-.49,1,0s.5.34.8,0a1.64,1.64,0,0,1,.82-.43,9.85,9.85,0,0,1,1.33,0h1.56c.44,0,1,.29,1.3-.08.54-.71.92-.05,1.37,0s.69-.26,1-.6.72.66,1,.39c.62-.74,1.28-.43,1.93-.49s1.1.2,1.53-.16.85-.6,1.37,0,1.14,1,1.66-.26c.12-.29.61-.46.81-.29.48.42.92,0,1.33.09a2.09,2.09,0,0,0,1.37-.08c.48-.21,1,.13,1.45-.63.39.2.72.67,1.2.55s.31-1.48.87-1.47a1.22,1.22,0,0,0,1-.54c.12-.16.26,0,.28.29a1.62,1.62,0,0,1-.11.68c-.08.16-.26.18-.38.31a2.74,2.74,0,0,0-.25.42,2.21,2.21,0,0,0,.39.31c.49.27.8-.6,1.2-.63s.67.47,1,.52.27-1.08.64-1.21c.17-.06.33.55.56.27s.62-.71,1-.14a.89.89,0,0,0,.81.44c.86.09,1.78-.5,2.56.63.08.12.3.08.42,0,.46-.39.9-.83,1.35-1.25a1.32,1.32,0,0,0,1.45.66c.22,0,.52.13.65-.07.53-.81,1-.82,1.56-.06.09.12.41-.14.59-.32s.52-.49.79-.06c.42.67.78.47,1.14-.17.25-.44.52-1.11.92-.72s.57.56.89-.09a6.4,6.4,0,0,1,1-1.5c.15-.18.43-.09.65,0s.35.3.39.68c.22,0,.52-.08.62.12.46.86.73.35,1-.24a2.87,2.87,0,0,1,.35-.47c.06.31.14.63.2.95s.12.7.18,1.05c.12-.12.27-.2.35-.37.42-.94.84-1.35,1.47-.42.19.27.56.15.85.2.44.08.69-.21.76-1,0-.32.2-.41.28-.22s.08.51.17.67c1.09,1.81,2.43,1.32,3.73,1.13.12,0,.24-.27.35-.44.28-.43.54-.88.81-1.31s.32-.21.4.32c.22,1.51.4,1.83,1.09,1.43.35-.2.58-.43,1,0s.57.05.64-.61.4-.89.65-.62.6.49.94,0c.09-.13.42,0,.58.23.59.71,1.07.53,1.59-.27s.56-.76,1.19.3a.71.71,0,0,0,.82.36c.47-.06.41-.44.19-.92a.37.37,0,0,1,.13-.54.22.22,0,0,1,.22,0,1.29,1.29,0,0,1,.34.39c.45,1,.46,1.07.89.67.27-.24.48-.39.8-.19,1.47.88,2.58.94,3.78-.28.75-.76,1.19-.6,1.68.43.06.14.3.23.35.15.42-.67.8-.44,1.18.09.59-.68,1.25-.53,1.9-.53,2.38,0,4.75-.12,7.13,0a2.73,2.73,0,0,0,2.08-.87c.48-.46.72-.67.83.48,0,.3.2.24.32-.07.41-1.08.47-1.2.86-.74s.85.33,1.28.4,1.17-.17,1.68.61c.1.15.4-.06.6-.14s.12-.15.17-.24c.3-.55.59-1.18,1-.33.82-.43,1.73-.62,2-2.39.07-.41.39-.67.51-.46.49.88.9-.06,1.34-.07a3.24,3.24,0,0,0,2.56-1.82c.32-.5.83-.69,1.08-1.24.41-.9.74-.12,1.11-.12.59,0,1.31-1.5,1.38-2.57,0-.56-.14-1.08-.42-1.13s-.73-.06-1.09-.14-.24-.25-.09-.52c.66-1.21-.15-3.08.63-4.25l-.54-1.1c-.27-.56-.28-.65.2-.9s.19-.57.14-1,.42-1.23.64-1c.47.57,1,.44,1.49.41.1,0,.2-.24.28-.4a1.13,1.13,0,0,0-.12-.3,1.35,1.35,0,0,0-1-.83c-.56-.13-.85-1.24-.52-1.88.53-1,1-2.22,1.79-2.76a1,1,0,0,0,.06-1.4,3.92,3.92,0,0,0-1-.75c-.42-.16-.47-.41-.23-.95a.7.7,0,0,0,.12-.32,10.47,10.47,0,0,1,.9-4.84,4.76,4.76,0,0,0,.5-2.8,4.89,4.89,0,0,1-.23-1.61,1.77,1.77,0,0,1,.92-.91c.89-.5,1.64-1.63,2.62-1.79.24,0,.21-.59.18-1a.93.93,0,0,0-.13-.31c-.13-.31-.22-.65.08-.79.57-.25,1.18.23,1.73-.3.24-.23.06-1.08.44-1s.53.46.81.51a.94.94,0,0,0,1.23-.55l.27-.6C194.89,136.54,194.79,136.32,194.68,136.3Zm-5.66-22a.75.75,0,0,1,.17.1c.18.15.35.32.53.48v0l0,.07,0,0c0,.41-.12.67-.36.72s-.42-.2-.45-.62A3.32,3.32,0,0,1,189,114.3ZM143.47,75c0-.24.21-.06.25,0s-.17.16-.05.2c-.06.16-.26.13-.37.23C143.16,75.05,143.67,75.11,143.47,75Zm-1.54-.6.38,0A1.62,1.62,0,0,1,142,75C141.74,74.94,141.91,74.6,141.93,74.39Zm-.69,0c-.09.31.18.09.38.05.14.12-.07.24.08.28,0,.26-.35,0-.31.23-.16.08-.13-.18-.26-.17s.09.14,0,.3a.24.24,0,0,0-.2-.08.74.74,0,0,0,.05-.39c-.24.24-.08.36-.44.15,0-.25.2-.21.37-.23a.36.36,0,0,0-.2-.17C140.82,74,141,74.6,141.24,74.38Zm-1-.18c.13-.06.17,0,.25.06s-.11.1-.18.12,0,.44-.24.32c0-.1,0-.19,0-.29S140.3,74.37,140.29,74.2Zm7.65-5.47a.23.23,0,0,1-.23.11l0-.19C147.8,68.58,147.89,68.47,147.94,68.73Zm-3.2,2.21c.07.07.22,0,.24.14s-.26,0-.37.1A1.36,1.36,0,0,0,144.74,70.94Zm-1.59-3.87c0,.11,0,.17.07.19s-.12.07-.12.2C142.92,67.46,142.93,67,143.15,67.07Zm-.3.23a2.07,2.07,0,0,0-.1.26l-.3,0C142.54,67.24,142.64,67.11,142.85,67.3Zm-.52.22-.81-.1C141.72,67,142.35,66.94,142.33,67.52Zm-.94-.44c-.08,0-.18,0-.18.12.22-.09.17.07.16.21l-.51-.06c0-.1,0-.15,0-.21C141.05,67.44,141.2,66.73,141.39,67.08Zm-.52-.42c0,.09-.08.08-.13.11s0,.17.08.18c0,.3-.22,0-.26-.06S140.76,66.73,140.87,66.66Zm-1.47-.41c0,.1.08.15,0,.19s-.21-.1-.29-.2Zm7-2.62c0,.33-.16.14,0,.48l-.13,0c0-.08,0-.09-.06-.09S146.26,63.64,146.44,63.63Zm-1-.27c-.11.48-.71.31-.87.19C144.74,63.13,145.37,63.38,145.48,63.36Zm-1.2-.15c0,.24-.2.21-.37.23C143.84,63.1,144.16,63.28,144.28,63.21Zm-3.36-.58c0,.37-.17,0-.37.23C140.48,62.53,140.79,62.7,140.92,62.63ZM139,66.24c0,.28-.22.1-.47.3,0-.13.1-.17.11-.3-.2,0-.52.15-.66,0l0,0C138.35,66.21,138.67,66.22,139,66.24Zm-1-1.46a.5.5,0,0,1,.51-.41A.9.9,0,0,0,138,64.78Zm.44-2.54a.33.33,0,0,1,.31-.13c0,.17-.07.21,0,.39.18-.09.25-.61.49-.34-.29.12,0,.49-.3.32.08.31.39.22.47.52s-.27.07-.37.14c0-.28-.16-.28-.16-.56-.11.21-.2.45-.41.53C138.38,62.59,138.75,62.64,138.45,62.24Zm-.3.32c0-.13.15-.09.25-.12a2.66,2.66,0,0,0-.1.68c-.23.13-.21-.18-.32-.25S138.36,62.68,138.15,62.56Zm-3.85,4.85c.17-.31.34-.12.68-.27C134.94,67.67,134.6,67.28,134.3,67.41Zm.1-.5a.46.46,0,0,1,.23-.06.14.14,0,0,1,0,.14A.22.22,0,0,1,134.4,66.91Zm.66.7a.87.87,0,0,1,.1-.5,2.47,2.47,0,0,1,.28.4v.06C135.25,67.5,135.24,67.5,135.06,67.61Zm.43,1c.36-.07.64,0,.6.61C135.7,68.92,135.9,68.86,135.49,68.61Zm1.61,7.29c-.16,0-.11-.36-.27-.35C136.94,75.24,137.28,75.69,137.1,75.9Zm.91-.77c0,.3-.1.35,0,.67-.2,0-.53.1-.58-.22C137.93,75.68,137.76,75.27,138,75.13Zm-.14-10.62a1.07,1.07,0,0,1,0,.41s-.06.06-.1.08-.21,0-.29.11a.86.86,0,0,1-.32,0,1,1,0,0,1,.54-.29c0-.14-.09-.49,0-.48S137.85,64.41,137.87,64.51Zm0,1.92-.05,0,0,0S137.9,66.4,137.9,66.43Zm-.27-4.29c0,.1,0,.2,0,.29l-.19,0c.08-.29.05-.11-.13-.08C137.32,62.16,137.47,62.15,137.63,62.14Zm.21.56c0,.24-.24.1-.17.4-.12,0,0-.44-.26-.26.25.23,0,.34-.13,0C137.38,62.51,137.65,62.54,137.84,62.7Zm-.55,1.5c0,.16-.1.25,0,.28,0,.24-.21,0-.25,0a3.24,3.24,0,0,1,.09.56h-.06a.39.39,0,0,1-.17-.11l-.06-.07c.11-.06.08-.33.07-.56C137.11,64.38,137.09,64.15,137.29,64.2Zm-.51.62-.24-.26c.07,0,.1.12.2.08s-.24,0-.2-.36c.17-.1.17.12.31.06A2.14,2.14,0,0,0,136.78,64.82Zm.05-2.3c.06.35-.26.2-.3.42-.21-.06,0-.21-.14-.37-.1.17-.36.12-.56.16C136.16,62.15,136.5,62.47,136.83,62.52Zm-.22.6c-.25.35-.62-.23-.88.1C135.88,62.74,136.35,63.15,136.61,63.12Zm-.13,1.26c0,.05,0,.06-.06.09l-.2-.16A.27.27,0,0,1,136.48,64.38Zm-.9,3.37h0c.07.14.4.1.52-.05s0,0,.07-.07a5.27,5.27,0,0,1,.84.09c-.06,0-.1-.14,0-.15a.38.38,0,0,1,.22.07c.09.1.18.23.27.35a.5.5,0,0,0-.28,0c.13.23.42.16.53.42-.47,0-.63-.46-.91-.47,0,.51.33.59.54.8.12.55-.52.2-.65.75a1.46,1.46,0,0,0,.91-.68.67.67,0,0,0,.3.32,1.32,1.32,0,0,1-.08.33,3.08,3.08,0,0,0-.51,0c.1,0-.07.14-.14.28l-1.05-.09c0-.13-.13-.27,0-.34,0,.28.5.21.51.13s0-.1,0-.19c-.58.35-.74-.78-.16-.65a.72.72,0,0,0,.09.37c.12-.07.44.1.36-.23-.48.2-.18-.46-.54-.71-.07,0,0,.41-.16.5-.15-.23,0-.55-.1-.66-.22.14-.08.41-.15.59-.25,0-.45-.3-.15-.46a.26.26,0,0,1-.32-.15S135.57,67.8,135.58,67.75Zm-1-5.26c0-.34.32,0,.36-.42.07.07.3.65.32.16.1,0,.17.12.26.16-.05.37-.44.31-.6.54.06-.36-.32-.27-.71-.3a.6.6,0,0,0,.05-.29C134.44,62.23,134.44,62.47,134.56,62.49Zm-.27-.54c0,.32-.24.28-.29.51-.14-.12,0-.24-.09-.47C134.05,62.19,134.09,61.93,134.29,62Zm-.41.72c-.09,0-.18,0-.18.11C133.48,62.63,133.89,62.1,133.88,62.67Zm-.41,5.7c.14.08.38,0,.5.13-.15.27-.53.16-.86.39C133.15,68.61,133.53,68.78,133.47,68.37Zm-.13,0c-.13.12-.53.6-.56.06C133.06,68.39,133.08,68.31,133.34,68.38ZM130,57.17a.36.36,0,0,1,0,.23l-.11-.16A.91.91,0,0,0,130,57.17Zm-3.6.94h.18c-.06.14-.15.24-.24,0C126.4,58.14,126.42,58.13,126.43,58.11Zm-.23,0a.47.47,0,0,1,0,.24c-.2.12-.23-.1-.29-.23Zm-.43.78c0,.34-.21.13-.31,0S125.73,58.85,125.77,58.9Zm21.12-5.47c-.22.06-.36,0-.33-.35.07.1.22.08.37.05A.84.84,0,0,0,146.89,53.43Zm-.18-1.13c.06.45.11.29.39.34,0,.19,0,.25,0,.38-.24-.17-.28-.06-.63,0,.15-.26.2-.13,0-.48C146.47,52.22,146.53,52.46,146.71,52.3Zm-1.06.21c.13,0,.13.25.2.36.17-.16.26,0,.5-.15.07.33-.08.34-.18.21,0,.4.41,0,.34.44-.23.05-.31-.14-.51-.13,0-.1.12-.08.11-.2C145.93,52.93,145.49,52.88,145.65,52.51Zm.09.57c.27.13.08.59.52.51,0,.09,0,.18-.11.21-.31,0-.27-.56-.59-.51C145.57,53.15,145.74,53.24,145.74,53.08Zm-.33-.35c-.15.44-.77.19-1,.12C144.6,52.27,145,52.85,145.41,52.73Zm-1.26,0c0,.36,0,0,.19.07-.09.57-.3-.07-.42.33C143.8,53.05,144,52.68,144.15,52.69Zm-.32,0c-.09.22-.4.48-.55.35C143.39,52.52,143.58,52.87,143.83,52.72Zm4.13-7c-.25-.15.29.08.06-.11.09-.11.3.11.44,0,0,.11-.11.09-.18.12s0,.19-.12.2C148.12,46.21,148.17,45.71,148,45.74Zm.29.92c0,.11,0,.17.08.18-.34.3,0-.62.23-.31C148.58,46.74,148.34,46.6,148.25,46.66Zm.59.41c-.08,0-.07.3,0,.29-.28.16-.09-.15-.27-.45.09.12.3,0,.39.15S148.85,47.17,148.84,47.07Zm.25-1.27c0-.39.26,0,.5-.15C149.65,46,149.16,45.88,149.09,45.8Zm.18-.31a1.41,1.41,0,0,1-.53-.42c0-.32.27-.12.32.06.28-.53.71-.12,1.05-.31.07.41.23,0,.4.34C150.26,45.49,149.56,45,149.27,45.49Zm1.43-.35c0-.25.07-.38.23-.41a.82.82,0,0,1,.08.47A.29.29,0,0,1,150.7,45.14Zm2,.06c-.13.15-.46,0-.52-.33C152.38,45.14,152.63,44.69,152.71,45.2ZM155,42.35c.16.19,0,.37,0,.66-.29,0-.18-.17-.51,0-.11-.32.21-.08.17-.3s-.4.16-.32-.25C154.66,42.38,154.81,42.56,155,42.35Zm5-1.63c0,.24-.23.24-.36.33C159.63,40.62,159.89,40.67,160,40.72Zm-2.4-.2c-.19.23-.31,0-.5,0,0-.13,0-.25,0-.38A.48.48,0,0,1,157.64,40.52Zm-3.42,2.21c-.07-.11-.22-.09-.37-.06C153.85,42.35,154.28,42.18,154.22,42.73Zm-.53-1.86c.08.28-.4.29-.36.23C153.25,40.76,153.57,40.94,153.69,40.87Zm-1-.74c-.07.3-.43.15-.57,0C152.07,39.54,152.56,39.94,152.65,40.13Zm-.49,9.25c-.14.23-.08.32,0,.67-.33,0-.4-.29-.56.16-.27-.16-.57-1.07-.12-1.14C151.39,49.56,152,49.08,152.16,49.38Zm-.36-.92c0,.23-.29,0-.17.31a.3.3,0,0,0-.32-.06C151.21,48.13,151.67,48.31,151.8,48.46ZM151.63,45c0,.22-.3.07-.43.15C151.19,44.78,151.53,44.84,151.63,45Zm-1.82-2.47.88-.1c0,.51.17.3.39.24.16.15-.36,0-.11.39-.22,0-.3-.32-.51-.13,0-.09,0-.19,0-.29-.2,0-.32.23-.56.07-.06,0,0,.12-.06.2C149.64,42.89,149.88,42.73,149.81,42.56Zm-.37.13c.09-.37.12.2.2.17,0,.27-.3.26-.48.35C149,42.79,149.67,42.94,149.44,42.69Zm-1.51-.21a.9.9,0,0,1-.1.59c-.19,0-.33-.18-.34-.54Zm-.57.07c-.15.44.22.21.16.75a2.38,2.38,0,0,0-1.35-.62C146.52,42.31,147.05,42.85,147.36,42.55Zm-1.67,1.72a.33.33,0,0,1,.36-.23A.24.24,0,0,1,145.69,44.27Zm.37-1.29c-.21-.08-.1-.17-.38,0C145.63,42.56,146.11,42.71,146.06,43Zm-14.7,10.49c0-.21,0-.31.17-.31-.41,0-.25.19-.74.28,0-.17-.09-.19-.08-.37.31.13.56-.36.87-.2C131.58,53.17,131.56,53.44,131.36,53.47Zm.37-.14c-.15-.06-.09-.58.1-.49C131.94,53.19,131.67,53,131.73,53.33Zm4.72-5c0-.4.22-.28.37-.23C136.89,48.4,136.58,48.22,136.45,48.29Zm1.2.15c-.05-.43.28-.29.43-.24C138.15,48.56,137.79,48.36,137.65,48.44Zm1.11-.41c.15.12.09.61.34.53,0,.44-.28.07-.37,0C138.67,48.32,138.78,48.25,138.76,48Zm.41.62c.1-.15.28-.42.43-.24A.46.46,0,0,1,139.17,48.65Zm.41,3.21c-.05.35-.63.26-.69,0C139.18,51.74,139.32,51.91,139.58,51.86ZM139,48c.23-.17.13.25.32.15C139.32,48.43,138.91,48.49,139,48Zm.76,5.28c-.11-.08-.15-.29-.15-.56h-.13c-.09,0,0,.12,0,.29-.12,0-.13-.26-.32-.16,0-.1.12-.08.11-.2s-.2.26-.43.14a.58.58,0,0,1,.86-.29C139.52,52.9,139.81,53.05,139.71,53.29Zm.6-.65c.28.1.35-.07.69-.08C140.86,52.86,140.38,53.23,140.31,52.64Zm3-1.77c-.2.21-.46.33-.53.73.25-.13.31-.5.67-.46,0,.14-.08.25-.1.39s-.15-.16-.32-.06c.24.42-.57.54-.81.19,0-.35.18-.08.37-.14s0-.29.11-.3c0-.21-.27,0-.38,0s0-.38-.2-.36c0-.21.27,0,.31.06.13-.39.43-.31.54-.54C143.15,50.37,143.09,50.87,143.3,50.87Zm.58-6.2c.38.14.6,0,.82.1-.06.73-.77.64-1.1.6C143.56,45,143.79,44.9,143.88,44.67Zm-.36.33c0,.12,0,.25,0,.38-.24.12-.21-.26-.27-.45A.24.24,0,0,0,143.52,45Zm-.2,3.56a.65.65,0,0,1-.1.49C142.9,49.13,143,48.4,143.32,48.56Zm-1-9.17c.08-.27.35,0,.33.25C142.39,39.79,142.47,39.38,142.3,39.39Zm-.72,10.91c.16-.5.75-.3.71-.85a1.28,1.28,0,0,0,.58.22c.06-.26.38-.51.55-.35-.22.62-.61.61-.89,1.25a.41.41,0,0,0-.43,0c-.1-.13.25-.44.48-.44-.26-.46-.77.22-1.06.31-.05-.29,0-.39-.08-.47C141.5,49.73,141.71,50.21,141.58,50.3Zm.35.72c-.23-.38-1,.34-1.13,0,.29-.45.86-.12,1.11-.41C141.81,50.84,141.92,50.76,141.93,51Zm-.54-.61c-.37.07-.39-.5,0-.28A2.62,2.62,0,0,1,141.39,50.41Zm-.16-2.18c.1.1-.24,0-.44.14C140.76,47.89,141.11,48.12,141.23,48.23ZM140.81,50c.16,0,.26.72,0,.58C140.92,50.36,140.7,50.16,140.81,50Zm.32,1.5c.2.81.63-.13.78.48.05,0,.06-.1.12-.11s-.2-.06-.14-.36c.36-.06.22.73.58.41-.56.53-1.31-.14-2,.32,0-.09-.08-.07-.13-.08.1-.31.24-.3.22-.6.13-.06.13.12.14.27C140.85,51.72,140.9,51.48,141.13,51.5Zm-.42-3.6c0,.31-.4.27-.38,0C140.48,47.82,140.63,47.8,140.71,47.9Zm-.4,3.4c.08.31-.19.17-.31.23C140,51.29,140.17,51.11,140.31,51.3Zm-.12,1.55c-.15-.07-.18-.37-.45-.24C139.75,52,140.23,52.42,140.19,52.85ZM130,45.77c0-.12,0-.25,0-.38C130.2,45.29,130.22,45.82,130,45.77Zm-.08-.37c-.15-.2-.21.1-.44.05.09-.2,0-.12,0-.38C129.67,45,129.87,45.06,129.9,45.4Zm-1.28.91a.2.2,0,0,0,.38,0c0-.16-.12-.2-.26-.16.23-.26.61-.12,1-.21-.07.14,0,.15,0,.29.11-.2.25-.1.32.06.28-.44,1.51.1,1.33-1a1.26,1.26,0,0,0,1.11-.41c.09.15.26.16.33.35.09-.44.77-.42,1.13-.13.16,0,.14-.23.24-.32.59,0,1.29.18,1.83.18a.42.42,0,0,0,.7.3c.24.18,1.11.47,1.39-.06.25-.06,0,.13.08.37a1.06,1.06,0,0,1,.93-.11c-.28.4.34.63.6.7-.23.3-.57-.08-.76-.2-.09.12-.12.33-.3.33,0-.08.06-.11,0-.2a3.81,3.81,0,0,1-2.44.18c-.18.14-.56,0-.61.36a2.91,2.91,0,0,0,1.82-.12.65.65,0,0,0-.05.3c0,.12.61-.32.52.32.21-.54.42,0,.53-.63.28-.05.57-.11.58.32-.19.06-.25-.19-.37,0,.2,0,.33.24.46.42.05-.07-.06-.44.1-.58.27,0,.4.32.59.5-.14.21-.38.29-.48.54-.13.06-.13-.12-.14-.27-.37.3-.38.14-.87.19.07.38.18.37,0,.76-.31-.14-.25-.37-.48-.71.19-.09.14.25.32.16s-.06-.17.06-.2c-.33-.45-.51.41-.88.1-.05-.15.29-.19.25,0,.19-.34-.59-.21-.22-.65-.11,0-.12.14-.24.13a.6.6,0,0,1,.07.28c-.21,0-.48-.19-.49.24-.15-.21-.21-.12-.44,0-.08-.37.33-.11.36-.33-.18-.27-.34.06-.51-.23-.07.32.2,0,.14.37-.22,0-.29-.24-.51-.23-.12-.33.21-.08.17-.31s-.21.2-.32-.06c-.15.09.22.27,0,.48-.21-.23-.17-.41-.52-.23a.74.74,0,0,0,.05-.39c-.22,0-.09.36-.24.41-.57-.74-1.2,0-1.84-.36,0,.28-.53.3-.51-.14-.17.26-.11.29-.42.34-.23-.73-1.37.15-1.84-.27,0-.26.08-.34.18-.21,0-.08-.06-.09-.07-.19-.15.37-.84.72-1.06.22-.3.37-.61.11-1,.11C128.46,46.52,128.61,46.51,128.62,46.31Zm-2.38-7.58c-.11,0-.12-.06-.13-.18-.18,0-.13.38-.31.13C125.85,38.43,126.23,38.36,126.24,38.73Zm-.66,16.17c0,.12,0,.25,0,.38l-.38,0A.42.42,0,0,1,125.58,54.9ZM107.17,22.41h0l.18.34-.09.13h0c0-.18-.09-.2-.09-.37h0ZM106,22.32l0,0h0ZM8.84,46.93a1.43,1.43,0,0,1-.17.58c-.16.16-.3-.08-.19-.32s.23-.19.36-.26l0-.13.05.1Zm1,4.92s0-.06,0-.1-.29-.15-.35-.31.06-.51.2-.33a.79.79,0,0,1,.11.33c0,.1,0,.21,0,.31l.06,0Zm3.63,15.36s.13-.17.2-.27c.06.12.18.3.16.35C13.71,67.72,13.57,67.69,13.49,67.21Zm-1.71,40.68s-.1-.14-.12-.24a.59.59,0,0,1,.07-.23s.11,0,.14,0A.29.29,0,0,1,11.78,107.89Zm-.89,6.88c-.07-.3-.14-.6-.2-.92,0,0,.09-.17.14-.23a.11.11,0,0,1,.12,0c.05,0,.08.11.11.21a1.4,1.4,0,0,1,0,.43Zm1.63.06a1.09,1.09,0,0,1-.62,0c-.08,0-.14-.26-.19-.43a.38.38,0,0,1,.15-.22,1,1,0,0,1,.31-.06c.16,0,.24,0,.3,0s.22.22.34.33C12.71,114.59,12.62,114.8,12.52,114.83ZM18,155.58H18s.05,0,.06,0A.3.3,0,0,1,18,156s-.1-.14-.12-.24S17.93,155.65,18,155.58Zm-1.47.54a.29.29,0,0,1,0,.09c.11.06.24.1.29.22s0,.42-.15.28a1.25,1.25,0,0,1-.14-.5l-.05,0Zm-.62,7.72a3,3,0,0,1,.56.34l-.35.36-.38-.24C15.75,164.13,15.83,163.82,15.86,163.84Zm.84,6.22c-.23,0-.44.35-.66.55v.09h0a1.73,1.73,0,0,1-.59,1.35.72.72,0,0,1-.38.13c-.06,0-.13-.09-.18-.17a.45.45,0,0,1,0-.25c.26-.81.66-1.17,1.19-1.06a.11.11,0,0,0,0-.06l0,.06,0-.06,0,0c0-.68-.08-1.39.52-1.51.21,0,.32-.33.36-.68h.42C17.39,169.25,17.36,170,16.7,170.06Zm.19-1.73a1.46,1.46,0,0,1-.25-.13.12.12,0,0,1,0-.08c-.06-.41.12-.45.29-.47Zm1.43,1.92s.1-.15.14-.21.16.21.15.24C18.51,170.64,18.4,170.63,18.32,170.25Zm.2-3.52a4.09,4.09,0,0,0-.28,1c-.16.82-.54.61-.88.63,0-.43-.19-.68-.44-.75l-.18-.61c-.06-.21-.12-.41-.19-.62.13-.09.3-.31.38-.24a.81.81,0,0,0,1.31,0c.05,0,.14,0,.21,0S18.65,166.44,18.52,166.73Zm1.75-6.59a.62.62,0,0,1,1,.13c-.07.16-.13.43-.2.43a2.71,2.71,0,0,1-.79-.12c-.05,0-.1-.15-.15-.23A1.29,1.29,0,0,1,20.27,160.14Zm.53,3.93v.22l-.27-.13c0-.06.09-.15.14-.18S20.76,164,20.8,164.07Zm0,13.25a.61.61,0,0,1-1,0c-.09-.08-.11-.33-.15-.53h-.06l0-.08s0,.05,0,.07a1.19,1.19,0,0,0,.93-.49c.35-.44.8-.3.72-.05A3.06,3.06,0,0,1,20.76,177.32ZM171.05,86.66a1.93,1.93,0,0,0,.17.2h-.87a.53.53,0,0,1,.06-.13C170.62,86.62,170.93,86.49,171.05,86.66ZM163.66,86s.09.07.14.11,0,.19,0,.24c-.09.21-.19.16-.27-.14C163.51,86.17,163.61,86,163.66,86Zm-5.35-.79.18.18.5.65c-.16.26-.23.49-.31.49-.28,0-.56-.08-.53-.73A3.23,3.23,0,0,1,158.31,85.2Zm-9.06.19a.65.65,0,0,1,.6-.25c.26.06.67,1.08.65,1.42,0,.15-.07.3-.11.46h-1.72a.24.24,0,0,0,0-.08A2.81,2.81,0,0,1,149.25,85.39Zm-2.86-2.55a2.8,2.8,0,0,1,.54.33l-.34.34-.36-.23C146.28,83.12,146.36,82.82,146.39,82.84Zm-4.48-.61a1.36,1.36,0,0,1,.14.5l0,0,0,.06a.29.29,0,0,1,0-.09c-.11-.06-.24-.11-.29-.24S141.8,82.08,141.91,82.23Zm-.15,1.6c.05-.12.18-.17.29-.23s0,0,0-.08l0,.06,0,0a1.25,1.25,0,0,1-.14.49C141.79,84.22,141.68,84,141.76,83.83Zm-3.91-2.45c.05,0,.09.14.13.22s0,.14-.07.21l-.2-.24C137.76,81.5,137.81,81.37,137.85,81.38Zm-6.31-19c.11.22-.2.3-.18.12-.08.05-.06.1,0,.16l-.17,0a1.29,1.29,0,0,1-.05-.21Zm-.51,0a.75.75,0,0,1,0,.28l-.12,0s0,0,0-.06-.18-.19-.26-.06,0,0,0,.08c-.19,0-.38-.1-.57-.16a.72.72,0,0,0,0-.34C130.44,62,130.69,62.19,131,62.32Zm-.73-.78c0,.15-.05.17,0,.29-.17.09-.14-.17-.26-.16C130,61.47,130.22,61.6,130.3,61.54Zm-2-.44-.12-.06-.3-.36C128.09,60.63,128.22,60.81,128.27,61.1Zm-1-.94s.06,0,.07.06l-.09,0A0,0,0,0,1,127.28,60.16ZM126,59.83a.59.59,0,0,0,0,.2l-.21,0C125.69,59.85,125.77,59.72,126,59.83ZM124,55.12c0-.14,0-.26.15-.26a.77.77,0,0,1,0,.3Zm1.07,4.33c.13.17,0,.18,0,.48h0l-.15,0c0-.08-.06-.23-.16-.22C124.85,59.53,125,59.52,125.11,59.45Zm0-4.22c-.19-.15-.51-.07-.47-.62C124.84,55,125.13,54.58,125.16,55.23Zm-.28-17.4c.05.37-.37.19-.32-.06C124.71,37.71,124.7,37.93,124.88,37.83Zm-.26,21.87a.22.22,0,0,1,0,.13,1.65,1.65,0,0,1-.25-.15A.46.46,0,0,1,124.62,59.7Zm-.32-20.85c-.18-.07-.44,0-.4-.43C124.11,38.42,124.29,38.49,124.3,38.85Zm-.77,18.67h0l0-.05Zm-.44-.43.18.18c-.12,0-.25,0-.4.14A.44.44,0,0,1,123.09,57.09Zm-2.46,114c-.11.35-.22.34-.3,0,0,0,.1-.15.15-.22C120.53,170.91,120.64,171,120.63,171.07ZM121,38.46a.31.31,0,0,1-.31.23C120.59,38.29,120.93,38.35,121,38.46ZM117,45.72c0,.22-.09.36-.23.41,0-.12,0-.25,0-.38Zm-2-11c0-.21-.1-.17-.2-.17a.59.59,0,0,1,.72.5c-.31,0-.51-.28-.89-.19A.21.21,0,0,1,115,34.74ZM111,32c0,.25-.12.26-.24.31C110.65,32,110.82,31.87,111,32ZM96.6,23.82l.18-.37.17.28c-.07.07-.13.15-.19.22Zm2.25,0a.72.72,0,0,1,.23-.17c.08-.05.17-.08.24-.13h0l.48.32c0,.12-.09.25-.14.36a3.85,3.85,0,0,1-.37.64.51.51,0,0,1-.42.16C98.71,25,98.68,24.07,98.85,23.86ZM96.3,16.63a3,3,0,0,1,.48-.23h0l.32.39.08.09-.1.14a.38.38,0,0,1-.11.11c-.25.14-.51.28-.69-.22C96.26,16.84,96.27,16.64,96.3,16.63ZM90.65,33.52v0a.85.85,0,0,0-.14.11C90.56,33.58,90.61,33.51,90.65,33.52ZM89.57,14.86l.24.72h0c-.08.24-.15.48-.22.72-.11-.12-.33-.31-.32-.36A10.17,10.17,0,0,1,89.57,14.86Zm-2.4-.13c.06,0,.14,0,.18,0a.34.34,0,0,1-.12.52s-.12-.18-.14-.3S87.15,14.81,87.17,14.73ZM17.07,85.79c.06.13.17.3.16.36-.13.45-.27.43-.34-.06C16.88,86,17,85.89,17.07,85.79Zm-1.61,5.5s0,.06,0,.08.31.18.37.35-.07.51-.21.33a1.94,1.94,0,0,1-.16-.68l-.05,0Zm-.32,12.17c.62-.28,1,.77,1.56.88.05,0,.09.16.14.24a.62.62,0,0,0,.06.17s-.09-.1-.19.13-.38.75-.46.69A9.89,9.89,0,0,1,15,104.32a2.06,2.06,0,0,1-.23-.58A2,2,0,0,1,15.14,103.46Zm1.2,3.28a.88.88,0,0,1,0,.23c-.08.19-.18.15-.26-.13a.56.56,0,0,1,.14-.2S16.31,106.71,16.34,106.74Zm-1,21.85a3.88,3.88,0,0,1-.59,0s0,.05,0,.07l0-.06h0c0-.54.21-.78.52-.66.09,0,.16.27.22.43S15.35,128.58,15.3,128.59Zm1-7.87c-.15.34-.34.25-.53.11a1.53,1.53,0,0,1-.15-.23c.06-.08.1-.18.16-.22s.37-.28.52.15A.6.6,0,0,1,16.32,120.72Zm1-11.11a1.26,1.26,0,0,1-.24.57c-.11.11-.28.07-.45.1-.61.38-1-.57-1.59-.77-.25-.09-.32-.42-.13-.75s.46-.62.48-.58c.48.85,1.1.43,1.65.61C17.24,108.86,17.4,109.18,17.31,109.61Zm.34-1.8-.19-.24a1.71,1.71,0,0,1,.13-.23l.12.24Zm-.08-2.21s-.1-.14-.12-.24,0-.14.06-.22.11,0,.14,0A.29.29,0,0,1,17.57,105.6ZM18.09,133l-.19-.24.13-.22.13.24C18.13,132.89,18.11,133,18.09,133Zm2.21,8.42a.38.38,0,0,1-.39.14.67.67,0,0,0-.06-.12c-.07-.13-.15-.27-.13-.3a5.25,5.25,0,0,1,.41-.78c0-.08.11-.11.17-.16a2.72,2.72,0,0,1,.15.61A1.07,1.07,0,0,1,20.3,141.45Zm2-1.38a1,1,0,0,1-.63,0c-.07,0-.14-.28-.18-.44a.37.37,0,0,1,.15-.23,1.87,1.87,0,0,1,.4-.07c.07,0,.15,0,.21,0s.24.22.36.33C22.52,139.83,22.43,140,22.32,140.07Zm.47-7.24c.06-.09.1-.21.16-.24a.77.77,0,0,1,.41-.11c.43,0,.66-.29.69-1,0-.09.19-.18.3-.21s.11.17.12.27c.13,1.3-.09,1.7-1.08,1.71a3.1,3.1,0,0,1-.46-.14C22.88,133,22.84,132.91,22.79,132.83Zm2.66,10.55a5.61,5.61,0,0,1-.5.48V144l0-.08,0,0c0-.55.06-1.17-.38-1.45a7.55,7.55,0,0,1-1.16-.86c-.29-.27-.25-.82-.26-1.32s.15-.75.34-.79a5.73,5.73,0,0,1,1.31-.07c.64,0,.43.5.21,1.06a1.23,1.23,0,0,0,.06,1c.15.27.29.56.45.8A.86.86,0,0,1,25.45,143.38ZM27,147.07a1.79,1.79,0,0,1,.4-.09,3,3,0,0,1,.4.11.24.24,0,0,1,.08.09.74.74,0,0,0,.08.13c0,.07-.08.16-.13.24s-.08.14-.13.15a1.12,1.12,0,0,1-.63,0c-.09,0-.15-.27-.23-.41S26.92,147.09,27,147.07Zm-2.81,24.66c0-.13.17-.17.28-.24s0-.06,0-.08h0c0-.41.12-.64.31-.69a.42.42,0,0,1,.22,0c.08,0,.15.27.21.43s-.09.21-.15.22a3.89,3.89,0,0,1-.59,0s0,0,0,.07l0-.06,0,.06-.05,0a1.31,1.31,0,0,1-.13.51C24.22,172.15,24.1,172,24.17,171.73Zm0,1.25a2.76,2.76,0,0,1,.17.46c-.15.39-.36.28-.55.18s-.09-.17-.14-.25A3.07,3.07,0,0,1,24.21,173ZM24,182.1l0,.06,0,0h0c-.07-.55-.3-.8-.6-.67a4.87,4.87,0,0,0-.76.64c-.05,0-.14,0-.2-.08a.63.63,0,0,1-.12-.23,8,8,0,0,1,1.53-2.5c.29.76.6,0,.89.06.06,0,.14.41.15.63C25,181.08,24.73,181.87,24,182.1Zm1.21,3.6c-.08.2-.18.15-.26-.14a.49.49,0,0,1,.14-.2s.09.07.13.11A.83.83,0,0,1,25.25,185.7Zm.3-7.6a1.25,1.25,0,0,1-.14-.49s0,0-.05,0l0,0a7.08,7.08,0,0,1-.92.66c-.07,0-.27-.2-.31-.38a1.31,1.31,0,0,1,.06-.69c.35-.59.81-.41,1.17.41l.05,0a.29.29,0,0,1,0,.09c.11.06.24.09.29.22S25.67,178.23,25.55,178.1Zm.56,6.87c-.09-.1-.27-.23-.26-.28a8.62,8.62,0,0,1,.2-.91c.07.19.13.38.2.58S26.16,184.76,26.11,185Zm2.26-2.55c-.51.78-.13,2.12-.63,2.94-.18.29-.44.52-.49.26a2,2,0,0,1-.06-.67c.56-.66.25-1.88.61-2.63.07-.14.31-.22.39-.13C28.44,182.46,28.4,181.9,28.37,182.42Zm.21-14.35c-.18-.17-.36-.48-.53,0-.3.7-.55,1.46-.85,2.15-.19.44-.46.57-.77.3s-.53-.39-.78-.62a2.34,2.34,0,0,1-.69-1.76c.23-.68.63-.54,1-.47.58.12.7-.54.89-1.25s.42-.69,1-.41c.21.1.44.07.65.15.41.18.49.45.46,1.47C28.87,167.83,28.93,168.39,28.58,168.07Zm.57,16.22s-.09-.14-.11-.23,0-.14.05-.2.11,0,.14,0A.28.28,0,0,1,29.15,184.29Zm1.31-2.08c-.14.25-.27.62-.53.42s-.35-.32-.52-.49v0l-.06,0a1.55,1.55,0,0,1-.13.49c-.12.14-.24-.06-.16-.26a.33.33,0,0,1,.15-.16l.14-.07a.36.36,0,0,1,0-.1l0,0c0-.44.14-.64.29-.72a1,1,0,0,1,.51,0c.14,0,.27.16.4.25A2.81,2.81,0,0,1,30.46,182.21Zm2.28-3.74s.09.16.14.25-.13.25-.16.22C32.51,178.78,32.51,178.59,32.74,178.47Zm.52,3.37a.46.46,0,0,1-.27.22.36.36,0,0,1,0,.11H32.9c0,.17-.07.33-.12.48s-.14,0-.14,0c0-.4.11-.43.26-.46l0-.09.06,0a1.26,1.26,0,0,1,.13-.47C33.23,181.46,33.34,181.65,33.26,181.84Zm4,5.38c-.08.19-.17.14-.25-.13a.46.46,0,0,1,.14-.2s.08.07.12.1S37.3,187.17,37.27,187.22Zm4-5.3-.19-.23c0-.07.09-.19.13-.19s.09.14.13.21A1.72,1.72,0,0,1,41.25,181.92Zm11.18,2.92a.2.2,0,0,1,0,.11c-.08.18-.17.13-.24-.15,0,0,.08-.16.13-.19s0,0,.06,0l.07.08Zm14.52,1a2.86,2.86,0,0,1-1,.06s0,0,0,.06h-.05c0,.2-.06.47-.12.49-.23.1-.25-.2-.27-.48h0s0-.07,0-.11-.25-.1-.3-.24.05-.4.17-.26a1.62,1.62,0,0,1,.13.5l0,0s0,.05,0,.08h.39a.13.13,0,0,0,0-.06h0a1.76,1.76,0,0,1,.77-1.43c.21-.13.45.11.46.5S67.06,185.84,67,185.87ZM84.87,182l-.12-.1c0-.1.09-.21.13-.32l.13.22Zm9.31.05c-.29.18-.54,0-.61-.55a1.15,1.15,0,0,1,.09-.62c0-.07.23,0,.32.12a4.52,4.52,0,0,1,.28.54C94.41,181.77,94.4,181.92,94.18,182Zm13.87-2.37-.18-.25c0-.07.09-.19.13-.19s.09.14.13.22Zm6.19,3.13c-.21-.17-.2-.37,0-.5,0,0,.09.18.14.27S114.27,182.8,114.24,182.78Zm6.33-4.78c-.23.2-.35-.13-.46-.36a5.92,5.92,0,0,1-.26-.81h-.07s0-.05,0-.09c-.33-.05-.76.22-.86-.67-.07-.6-.28-.82-.61-.81-.15,0-.3.05-.44,0-.34-.18-.74-1.16-.57-1.26s.66-.39.83-.18c.67.82,1.52.74,2.18,1.51a2,2,0,0,1,.21.46c-.12.09-.25.2-.38.28a.87.87,0,0,0-.36.7h0a.29.29,0,0,1,0,.09h.34c.35,0,.48.33.46.87A.51.51,0,0,1,120.57,178Zm3.25,2c0,.5,0,1,0,1.5,0,.14-.16.27-.26.38a.51.51,0,0,1-.13-.26q0-1.84,0-3.69a.92.92,0,0,1,.14-.28c.08.16.23.32.24.49,0,.62,0,1.24,0,1.86Zm1.18.38-.2-.24c0-.07.09-.2.14-.2s.08.14.13.22Zm1.26-.72c-.22-.16-.21-.35,0-.48,0,0,.09.17.14.25S126.29,179.72,126.26,179.7Zm6.09.5s.1-.15.14-.21.17.21.16.24C132.55,180.6,132.43,180.59,132.35,180.2Zm2-.63c-.08.18-.18.14-.26-.13a.46.46,0,0,1,.14-.19s.08.06.13.09A.83.83,0,0,1,134.38,179.57Zm4.88-.71h0l-.2-.22.14-.22.12.24Zm5.26-8.33-.16-.25h0c.06-.08.12-.23.17-.23s.1.17.15.26Zm3.66,1.49c-.19.26-.39.18-.57,0a1.07,1.07,0,0,1-.11-.95,2.1,2.1,0,0,1,.17-.33c.19.35.39.69.57,1.05A.39.39,0,0,1,148.18,172Zm.8,3.92a1.08,1.08,0,0,1-.12-.24s0-.14,0-.2h.14C149,175.64,149,175.79,149,175.94Zm2.86,3.37a.8.8,0,0,1-.18.37.3.3,0,0,1-.19.1c-.12,0-.25-.14-.38-.24a1.22,1.22,0,0,1,.07-.28,4.59,4.59,0,0,1,.44-.76s.12.08.21.18l.08.1A1.33,1.33,0,0,1,151.84,179.31Zm1.14.44a.7.7,0,0,1-.12-.24.61.61,0,0,1,.06-.21c.05,0,.11,0,.15,0A.3.3,0,0,1,153,179.75Zm.89-.77a.59.59,0,0,1-.11-.24c0-.05,0-.14.06-.2s.1,0,.13,0A.31.31,0,0,1,153.87,179Zm.26-4.49c-.07,0-.15,0-.29,0a1.48,1.48,0,0,1-.36-.06c-.06,0-.16-.21-.16-.23.06-.18.13-.45.22-.48a1.11,1.11,0,0,1,.65,0c.11,0,.2.26.3.41C154.37,174.26,154.25,174.39,154.13,174.49Zm1.89,1.44c-.29.16-.56-.23-.54-.73s.14-.61.39-.66.36.24.44.57S156.24,175.81,156,175.93Zm.36-2.26c-.16.14-.32.06-.36-.24,0-.1.15-.37.24-.38s.25.15.39.24A2,2,0,0,1,156.38,173.67Zm5-4.38c-.32.92-1,.25-1.34.93s-.34,1.39-.75,1.69a2,2,0,0,1-.87.28c-.87,0-.59-.59-.39-1.1-.17-.15-.33-.32-.51-.45a.39.39,0,0,1-.13-.52c.15-.27.3-.69.48-.75a10.87,10.87,0,0,1,1.5-.23c.5-.08.83-1.07,1.4-.77.14.07.3,0,.44.06a2.27,2.27,0,0,1,.4.26C161.53,168.89,161.45,169.09,161.38,169.29Zm3.67,2-.14-.11.15-.34.15.23Zm8.36-82.65.73-.09,0,0a.87.87,0,0,1-.46.3C173.59,88.8,173.47,88.71,173.41,88.64ZM176,179c-.62.21-1.29-.25-1.88.41-.06.07-.16.21-.18.18a.78.78,0,0,1-.22-.42c0-.22,0-.58.13-.63a6.24,6.24,0,0,0,1.56-.93c.27-.28.49.35.7.67a.81.81,0,0,1,.12.29C176.2,178.78,176.12,179,176,179Zm1.9-3.14c-.2-.18-.19-.37,0-.5,0,0,.09.17.12.25S178,175.92,177.93,175.9Zm10.25-56.27c.19-.12.38-.27.53.15-.05.12-.12.38-.15.37a2.85,2.85,0,0,1-.53-.3A1,1,0,0,1,188.18,119.63Zm-.7-15.38a1.26,1.26,0,0,1-.13.47c-.11.14-.22,0-.14-.25s.16-.17.27-.22a.3.3,0,0,1,0-.1l0,.06Zm.28,31.82a1.21,1.21,0,0,1-.19-.47,2.07,2.07,0,0,1,.11-.69c.08-.3.18-.59.28-.88h0s0-.07,0-.11-.22-.1-.27-.22,0-.38.15-.24a1.17,1.17,0,0,1,.12.46l.06,0a.19.19,0,0,1,0,.08c.23,0,.41.21.42.62A1.78,1.78,0,0,1,187.76,136.07Zm1.37-1.52-.19-.23.14-.21.12.23Zm.1-2.46a.63.63,0,0,1-1.13.07,1.1,1.1,0,0,1,0-1,2.3,2.3,0,0,1,.61-.81c.16-.11.57.92.56,1.37A1.79,1.79,0,0,1,189.23,132.09Zm1.37-2.63a1.36,1.36,0,0,1-.14.5c-.12.13-.23-.08-.15-.27s.18-.17.29-.23,0-.06,0-.08l0,.05Zm1.06,6.71c-.28.16-.55-.22-.53-.71s.13-.59.37-.64.36.23.44.55S191.88,136.05,191.66,136.17Z",
    isSelected: false,
  },
];

export const TempMYPhotoGallery = [
  {
    id: 1,
    date: "November 17, 2023",
    src: "/images/photos/add_my-photo_1.webp",
    isSelected: false,
  },
  {
    id: 2,
    date: "November 17, 2023",
    src: "/images/photos/add_my-photo_2.webp",
    isSelected: false,
  },
  {
    id: 3,
    date: "November 17, 2023",
    src: "/images/photos/add_my-photo_3.webp",
    isSelected: false,
  },
  {
    id: 4,
    date: "November 17, 2023",
    src: "/images/photos/add_my-photo_4.webp",
    isSelected: false,
  },
  {
    id: 5,
    date: "November 17, 2023",
    src: "/images/photos/add_my-photo_5.webp",
    isSelected: false,
  },
  {
    id: 6,
    date: "December 17, 2023",
    src: "/images/photos/add_my-photo_4.webp",
    isSelected: false,
  },
  {
    id: 7,
    date: "December 17, 2023",
    src: "/images/photos/add_my-photo_5.webp",
    isSelected: false,
  },
  {
    id: 8,
    date: "December 17, 2023",
    src: "/images/photos/add_my-photo_6.webp",
    isSelected: false,
  },
  {
    id: 9,
    date: "December 17, 2023",
    src: "/images/photos/add_my-photo_1.webp",
    isSelected: false,
  },
  {
    id: 10,
    date: "January 17, 2023",
    src: "/images/photos/add_my-photo_6.webp",
    isSelected: false,
  },
  {
    id: 11,
    date: "January 17, 2023",
    src: "/images/photos/add_my-photo_1.webp",
    isSelected: false,
  },
  {
    id: 12,
    date: "Fab 17, 2023",
    src: "/images/photos/add_my-photo_1.webp",
    isSelected: false,
  },
  {
    id: 13,
    date: "Fab 17, 2023",
    src: "/images/photos/add_my-photo_2.webp",
    isSelected: false,
  },
  {
    id: 14,
    date: "Fab 17, 2023",
    src: "/images/photos/add_my-photo_4.webp",
    isSelected: false,
  },
  {
    id: 15,
    date: "Fab 17, 2023",
    src: "/images/photos/add_my-photo_6.webp",
    isSelected: false,
  },
];

export const fontSizes = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
  61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
  80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
  99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
  115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129,
  130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
  145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159,
  160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174,
  175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
  190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200,
];

export const fontSizesSmalls = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
];

export const Fontfamilies = [
  {
    name: "Arial",
    value: "Arial",
    fw: [
      {
        name: "Regular",
        value: 300,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Abril Fatface",
    value: "Abril Fatface",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Anton",
    value: "Anton",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Bebas Neue",
    value: "Bebas Neue",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Blinker",
    value: "Blinker",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "ExtraBold",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
    ],
  },
  {
    name: "Borel",
    value: "Borel",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Bungee Inline",
    value: "Bungee Inline",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Bungee Outline",
    value: "Bungee Outline",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Cairo Play",
    value: "Cairo Play",
    fw: [
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "ExtraBold",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
    ],
  },
  {
    name: "Great Vibes",
    value: "Great Vibes",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Chewy",
    value: "Chewy",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Kalnia",
    value: "Kalnia",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "League Gothic",
    value: "League Gothic",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Monoton",
    value: "Monoton",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Montserrat",
    value: "Montserrat",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "Thin Italic",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "ExtraLight Italic",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "SemiBold Italic",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
      {
        name: "ExtraBold ",
        value: 800,
      },
      {
        name: "ExtraBold Italic",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Nixie One",
    value: "Nixie One",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Nunito",
    value: "Nunito",
    fw: [
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "ExtraLight Italic",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "SemiBold Italic",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
      {
        name: "ExtraBold ",
        value: 800,
      },
      {
        name: "ExtraBold Italic",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Oswald",
    value: "Oswald",
    fw: [
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Pacifico",
    value: "Pacifico",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Poppins",
    value: "Poppins",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "Thin Italic",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "ExtraLight Italic",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "SemiBold Italic",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
      {
        name: "ExtraBold ",
        value: 800,
      },
      {
        name: "ExtraBold Italic",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Quicksand",
    value: "Quicksand",
    fw: [
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Sacramento",
    value: "Sacramento",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Rubik Dirt",
    value: "Rubik Dirt",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Send Flowers",
    value: "Send Flowers",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Six Caps",
    value: "Six Caps",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Ubuntu",
    value: "Ubuntu",
    fw: [
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
    ],
  },
  {
    name: "Wire One",
    value: "Wire One",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Alumni Sans Pinstripe",
    value: "Alumni Sans Pinstripe",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
    ],
  },
  {
    name: "Raleway Dots",
    value: "Raleway Dots",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Coiny",
    value: "Coiny",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Mr De Haviland",
    value: "Mr De Haviland",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Ms Madi",
    value: "Ms Madi",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Seaweed Script",
    value: "Seaweed Script",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Damion",
    value: "Damion",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Mr Dafoe",
    value: "Mr Dafoe",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Gasoek One",
    value: "Gasoek One",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Train One",
    value: "Train One",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Redressed",
    value: "Redressed",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Wendy One",
    value: "Wendy One",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Notable",
    value: "Notable",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Creepster",
    value: "Creepster",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Ultra",
    value: "Ultra",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Smooch",
    value: "Smooch",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Rubik Glitch",
    value: "Rubik Glitch",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
    ],
  },
  {
    name: "Roboto",
    value: "Roboto",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "Thin Italic",
        value: 100,
      },

      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },

      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },

      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Space Mono",
    value: "Space Mono",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
    ],
  },
  {
    name: "Fraunces",
    value: "Fraunces",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "Thin Italic",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "ExtraLight Italic",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "SemiBold Italic",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
      {
        name: "ExtraBold ",
        value: 800,
      },
      {
        name: "ExtraBold Italic",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Work Sans",
    value: "Work Sans",
    fw: [
      {
        name: "Thin",
        value: 100,
      },
      {
        name: "Thin Italic",
        value: 100,
      },
      {
        name: "ExtraLight",
        value: 200,
      },
      {
        name: "ExtraLight Italic",
        value: 200,
      },
      {
        name: "Light",
        value: 300,
      },
      {
        name: "Light Italic",
        value: 300,
      },
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Regular Italic",
        value: 400,
      },
      {
        name: "Medium",
        value: 500,
      },
      {
        name: "Medium Italic",
        value: 500,
      },
      {
        name: "SemiBold",
        value: 600,
      },
      {
        name: "SemiBold Italic",
        value: 600,
      },
      {
        name: "Bold",
        value: 700,
      },
      {
        name: "Bold Italic",
        value: 700,
      },
      {
        name: "ExtraBold ",
        value: 800,
      },
      {
        name: "ExtraBold Italic",
        value: 800,
      },
      {
        name: "Black",
        value: 900,
      },
      {
        name: "Black Italic",
        value: 900,
      },
    ],
  },
  {
    name: "Gujarati",
    value: "Noto Sans Gujarati",
    code: "gu",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Hindi",
    value: "Noto Sans Devanagari",
    code: "hi",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Marathi",
    value: "Baloo 2",
    code: "mr",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Bengali",
    value: "Noto Sans Bengali",
    code: "bn",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Tamil",
    value: "Noto Sans Tamil",
    code: "ta",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Telugu",
    value: "Noto Sans Telugu",
    code: "te",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Kannada",
    value: "Noto Sans Kannada",
    code: "kn",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Malayalam",
    value: "Noto Sans Malayalam",
    code: "ml",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Odia",
    value: "Noto Sans Oriya",
    code: "or",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Punjabi",
    value: "Noto Sans Gurmukhi",
    code: "pa",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
  {
    name: "Assamese",
    value: "Hind Siliguri",
    code: "as",
    fw: [
      {
        name: "Regular",
        value: 400,
      },
      {
        name: "Bold",
        value: 700,
      },
    ],
  },
];

export const EffectsList = [
  {
    label: "No Effect",
    value: "",
    effect: "",
  },
  {
    label: "B & W",
    value: "bw",
    effect: "0.3 0.7 0 0 0 0.3 0.7 0 0 0 0.3 0.7 0 0 0 0 0 0 1 0",
  },
  {
    label: "Blur",
    value: "blur",
    effect: "5px",
  },
  {
    label: "Gray Scale",
    value: "grayscale",
    effect: "100%",
  },
  {
    label: "Sepia",
    value: "sepia",
    effect: "100%",
  },
  {
    label: "Invert",
    value: "invert",
    effect: "100%",
  },
  {
    label: "Hue",
    value: "hue-rotate",
    effect: "180deg",
  },
];
export const ShadowList = [
  {
    value: " 0 5px 10px rgba(0, 0, 0, 0.5)",
  },
  {
    value: "0 -5px 10px rgba(0, 0, 0, 0.5)",
  },
  {
    value: "-5px 0 10px rgba(0, 0, 0, 0.5)",
  },
  {
    value: "5px 0 10px rgba(0, 0, 0, 0.5)",
  },
];

export const MagicWriteActionsJSON = [
  { value: "rewrite", label: "Rewrite" },
  { value: "summarize", label: "Summarize" },
  { value: "fix_spelling", label: "Fix spelling" },
  { value: "shorten", label: "Shorten" },
];
